"use strict"

// import Axios from 'axios';
import React, { useState, useEffect } from 'react';
import Utl from './Utl';

import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import InputBase from '@material-ui/core/InputBase';
import TextField from '@material-ui/core/TextField';
import Color from "./Color";
import Switches from "./Switch";
import Selects from "./Select";

import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/OpenInBrowser';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import AddIcon from '@material-ui/icons/Add';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';

import * as THREE from 'three';

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass';
import { MaskPass } from 'three/examples/jsm/postprocessing/MaskPass';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass';
import { AfterimagePass } from 'three/examples/jsm/postprocessing/AfterimagePass';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass';

import $ from '../node_modules/jquery';

var FRAGMENTSHADER;
(async () => {
  const res = await Utl.Axios.get("/fragmentShader.js");
  FRAGMENTSHADER = res.data;
  // console.log(FRAGMENTSHADER);
})()


var FXs// = ColorFX.concat(FlashInkFX).concat(MultiFx).concat(ScaleBlurFX);
var Banks
var RTFxs

var ENTIRE_SCENE = 0, BLOOM_SCENE = 1, BLOOM_IGNOR = 2, FX_SCENE = 3, DUMMY_SCENE = 4;

//イベントの振り分け
var EVENT = {};
if ('ontouchstart' in window) {
 EVENT.TOUCH_START = 'touchstart';
 EVENT.TOUCH_MOVE = 'touchmove';
 EVENT.TOUCH_END = 'touchend';
} else {
 EVENT.TOUCH_START = 'mousedown';
 EVENT.TOUCH_MOVE = 'mousemove';
 EVENT.TOUCH_END = 'mouseup';
}

const BANKS_INIT = [
  {
    "name": "",
    "val": {}
  },
  {
    "name": "StageFront LED[Ch123]",
    "val": {
      "group_dj_booth": true,
      "group_booth_wa": false,
      "group_booth_led": false,
      "group_booth_led_ch3": false,
      "group_stage": true,
      "group_BackStage": false,
      "group_BackStage_ch3": false,
      "group_led3": false,
      "group_led3_ch3": false,
      "group_led3_front": true,
      "group_led3_back": false,
      "group_led3_stage": false,
      "group_led3_front_ch3": false,
      "group_led3_back_ch3": false,
      "group_led3_stage_ch3": true
    },
    "thumb": "data:image/jpeg;base64,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"
  },
  {
    "name": "StageBack LED[Ch123]",
    "val": {
      "group_dj_booth": true,
      "group_booth_wa": false,
      "group_booth_led": false,
      "group_booth_led_ch3": true,
      "group_stage": true,
      "group_BackStage": false,
      "group_BackStage_ch3": false,
      "group_led3": false,
      "group_led3_ch3": false,
      "group_led3_front": false,
      "group_led3_back": true,
      "group_led3_stage": true,
      "group_led3_front_ch3": false,
      "group_led3_back_ch3": false,
      "group_led3_stage_ch3": false
    },
    "thumb": "data:image/jpeg;base64,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"
  },
  {
    "name": "FrontBack LED[Ch123]",
    "val": {
      "group_dj_booth": true,
      "group_booth_wa": false,
      "group_booth_led": false,
      "group_booth_led_ch3": false,
      "group_stage": true,
      "group_BackStage": false,
      "group_BackStage_ch3": false,
      "group_led3": false,
      "group_led3_ch3": false,
      "group_led3_front": false,
      "group_led3_back": true,
      "group_led3_stage": false,
      "group_led3_front_ch3": true,
      "group_led3_back_ch3": false,
      "group_led3_stage_ch3": false
    },
    "thumb": "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCAA6AFADASIAAhEBAxEB/8QAHQAAAgEFAQEAAAAAAAAAAAAAAwQJAAIFBgcIAf/EADEQAAIBBAECBAIJBQAAAAAAAAECAwAEBREGBzEIEiFBUWETFDJTYoGRkrEicYKisv/EABsBAAICAwEAAAAAAAAAAAAAAAAFAgQBAwYH/8QAKhEAAQQCAQIEBgMAAAAAAAAAAQACAxEEMVEhQQUSExQGFSIyQsGBkaH/2gAMAwEAAhEDEQA/APKVERaGO9MwrXpq5hosq5I6ZjtyfamrCya4YAKSTW02HFLqZQfq76P4aFehxnyfaFqS2p12r61qdfZroEPCbph6Wsn7aqXhV2ve1k/bQOqsewk4XOHtyPal5Itelb5fcTuolLG2cAfhrVchZG3cqw0RWVWlxnx/cFhXWh0zMtLHvWFScKKod6ctx8aUXvTkHehSZtb10/xy32XtYXXYeRQf1qV7NdKehXBsLDfX/AbEQArECiszEkE+7fI1Fn0sKjOWRb71f5qVLxFziDgMTMe92g/0akPi8kjXxNY4i7uiRwumhyJMLC9WJxB63RI0Bwi8X6fdE+S4pszjOEY+O2WQxlpU1/UAPxfMUPlnAuiPFbWG8y/BbFo52KoY4yRsf5fOuKdLOS5/OZKz4Da5C4isb25DOkYLAe7OQO4AGz7em/bddS8Qrrh+N4bFQrM0UbOBK+jvQAA2Pf8AL4Uq9SdsoaZXde3mOknZ8UZkkD5w402hfmOydb4WUwnSnoZzfDS3thwGwMJLRHzqwYHQPs3zqKHqFjUscvdQIugkjAfrUs3h8mE3BJmHtdv/AMLUVnVYqc5ekfet/NOvCJJHvma9xIHlqyTzym8uRJm4XqyuJPTZJ2DyuX3ApRvtGnbjtSTd6crmpNr4O9NwHVKDvR421QsNNFb5wLJJYZW1mdtKsik1IL4lfEl05yeEt+K8eyUmUuIp1lmntVDQjSspUMSPMfUHY2Ne9Rr4i7MLFx6FdaNZ6HNSnXnkJ1860TYMWU5r5Pxv/U0GWx2Mcd43+9qQjo7w3jnU/pi3JOISXJ5FY3f0N1bSTxDan1Vgvp5QQRos2iUfXwGe8TXNMdwPp1xriufkNzmZybl/LIjyxIoIPmG96YvoHeiYj316eDuEdV+V8FuHu+L8gvcZNKn0bvaztEWTYPlJUjY2AdfIUny7qLnuXZGXLZ/LXN/dza889xK0jtoADbEknQAH9hVP5ODNbnfQDdd9avhJ24eIxrg0EFwo9e1g/wB9Nr3H4b/El06x2FueK8gyUuMuJp2lgnulVYTtVUKWBPlOxvZ0Ne9R9c+ySX2WupkbYeRiP1oMmblBJWQj86wOXuzMwcnbNvZq/FhRYpc+P8qv+E392xuMMdg1+tLFTndKN3NHlbdLnvWxLHGyqosKtIdD8z8KFTluAI1171JosqN0moiqKFX2phJSOxpRe9XrW3SjadFywGvNVG6Yj7VKr3qmo7ItFaYkeppeYiQeVqpqsbvQi0jMrRnR7ex+NCp25AMZ2O1JVqcKKkDa/9k="
  },
  {
    "name": "Full LED[Ch123]",
    "val": {
      "group_dj_booth": true,
      "group_booth_wa": false,
      "group_booth_led": false,
      "group_booth_led_ch3": true,
      "group_stage": true,
      "group_BackStage": false,
      "group_BackStage_ch3": false,
      "group_led3": true,
      "group_led3_ch3": false,
      "group_led3_front": false,
      "group_led3_back": false,
      "group_led3_stage": false,
      "group_led3_front_ch3": false,
      "group_led3_back_ch3": false,
      "group_led3_stage_ch3": false
    },
    "thumb": "data:image/jpeg;base64,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"
  },
  {
    "name": "Stage LED[Ch2]",
    "val": {
      "group_dj_booth": true,
      "group_booth_wa": false,
      "group_booth_led": true,
      "group_booth_led_ch3": false,
      "group_stage": true,
      "group_BackStage": true,
      "group_BackStage_ch3": false,
      "group_led3": false,
      "group_led3_ch3": false,
      "group_led3_front": false,
      "group_led3_back": false,
      "group_led3_stage": true,
      "group_led3_front_ch3": false,
      "group_led3_back_ch3": false,
      "group_led3_stage_ch3": false
    },
    "thumb": "data:image/jpeg;base64,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"
  },
  {
    "name": "Back LED[Ch2]",
    "val": {
      "group_dj_booth": true,
      "group_booth_wa": false,
      "group_booth_led": true,
      "group_booth_led_ch3": false,
      "group_stage": true,
      "group_BackStage": true,
      "group_BackStage_ch3": false,
      "group_led3": false,
      "group_led3_ch3": false,
      "group_led3_front": false,
      "group_led3_back": true,
      "group_led3_stage": false,
      "group_led3_front_ch3": false,
      "group_led3_back_ch3": false,
      "group_led3_stage_ch3": false
    },
    "thumb": "data:image/jpeg;base64,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"
  },
  {
    "name": "Front LED[Ch2]",
    "val": {
      "group_dj_booth": true,
      "group_booth_wa": false,
      "group_booth_led": false,
      "group_booth_led_ch3": false,
      "group_stage": true,
      "group_BackStage": true,
      "group_BackStage_ch3": false,
      "group_led3": false,
      "group_led3_ch3": false,
      "group_led3_front": true,
      "group_led3_back": false,
      "group_led3_stage": false,
      "group_led3_front_ch3": false,
      "group_led3_back_ch3": false,
      "group_led3_stage_ch3": false
    },
    "thumb": "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCAA6AFADASIAAhEBAxEB/8QAHAAAAgIDAQEAAAAAAAAAAAAAAwQCCAUGBwAB/8QAMRAAAQMDAgQEBAYDAAAAAAAAAQACAwQFESExBhJBUQcTImEUMoGxCDNCkaHwcXLR/8QAGwEAAwEBAAMAAAAAAAAAAAAAAwUGBAABBwj/xAAnEQABBAIBAwQCAwAAAAAAAAABAAIDEQQxIQUGEhNBccEyUZGx8P/aAAwDAQACEQMRAD8A7CNTuptUQMBTA6Lmj2X1WV4NO6m1vdEij5jjCejt73DIaf2WyJhKA+VrNpEMz0UhH15U46lMZwQmIbe+UAAZW1rCTSC6doFkrFhmN18LCFmZbRJGMlhH0WPmhMZwQtIYW7XRztk/EpPBOgUnHDcfRSDNclDefVjsixtRxyUBSZqVFTj3U2wWUU6T1GzmlaMdVY/w14J4RuvCkU1XSx1VVJnzjzOBi1OBoe2uf+KudDpM0+6sh4HO5rTX67Pj+zlvosgLmmiKUB30+WPB9SJ5aQRo1ft9rFN4R4Z4VZJFdLbFXVUkpL3PibIAAdAwO2AG53JP+ANhsvAPCF68i9w20QBji10UbQxkgA2LRoCD1GOu+hEb7aH3K/Pp4G+uWbGcZx7n26rN0cj+HInW2CB7mGZ3I946Z0z74x+yXszcgvNmvhQeVn5EkLXRyu9V3J59v9pLcT+HNhutsljoqFkFSxhMZZ+ojocqtF+oTR1MkLhqxxardCYW+3Pq6t35bDI/J+uFVXiyVtTcqiZoGHSFydYD5JWODzdHj7VB2LmZMj5IpHFzRVE/tarL6G+4SwGThM1O+EBgxklMWil7UYeLS6JHuENTjKmom2VodpP0jsSNJ7qwXgBdqSto7nSQSF7mGNxcB6f1D+9FV6/TyRtgja8hjy4uA64xj7ravDbxTuXh7LU1Fvp6ec1MfluZOHFo1Bz6SNdP5XTZfi4wVx7/ANqe7l6DN1fpjmQcvNUNaK7zD4z8I0PEFb8ZT17RzlrXeUw4Of8Adbfw3x3YONat1NaqWseIRzukkYwMGD7OJ39lTesvD6qofO52TI4uK6T4Y+LjuCKOejZbqeYVLw98jubn0GAPmxgZPTOp12wOMMNgKW6z2JHHimXEaTLQAF8fKsDx9Ddq21/AWyklkD9Xlrc57DTXv0VaL9mOd7H7tJyuk1n4kp2RE0topufGnPzEfw4LidPcZKuSq5nkt5g5o7Zzn7Jxgy+AEBA+R9o3aHRc/p8TxlMDQKr9m9/xwvSnmJz1KG/0jCJucnogvPM4lNQOVeNQEGtroaCLzJNXHRjBu4/3qjDdaveHOdcpQ5xIbgDJ2GNlJTSmCPybvSYY0Inf4u0h1FZNVzGaZ2XHQDoB2CkyVw0yl27qbd0qYS51lOCwAUAnGzHujNrHs+UpJmylk91saaQXRtO0/wDHSlurt0vHXzwTieJ2HDcdCOxQz+X9EEfMtsRINheGRMoilt9JXw1tN5kejtntO7Svq1u1uc24xBriA7IODuMLZFR4cpmj8nbSfIhEL/Ful//Z"
  },
  {
    "name": "Full LED[Ch1-2]",
    "val": {
      "group_dj_booth": true,
      "group_booth_wa": false,
      "group_booth_led": true,
      "group_booth_led_ch3": false,
      "group_stage": true,
      "group_BackStage": true,
      "group_BackStage_ch3": false,
      "group_led3": true,
      "group_led3_ch3": false,
      "group_led3_front": false,
      "group_led3_back": false,
      "group_led3_stage": false,
      "group_led3_front_ch3": false,
      "group_led3_back_ch3": false,
      "group_led3_stage_ch3": false
    },
    "thumb": "data:image/jpeg;base64,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"
  },
  {
    "name": "Stage LED[Ch3]",
    "val": {
      "group_dj_booth": true,
      "group_booth_wa": false,
      "group_booth_led": false,
      "group_booth_led_ch3": true,
      "group_stage": true,
      "group_BackStage": false,
      "group_BackStage_ch3": true,
      "group_led3": false,
      "group_led3_ch3": false,
      "group_led3_front": false,
      "group_led3_back": false,
      "group_led3_stage": false,
      "group_led3_front_ch3": false,
      "group_led3_back_ch3": false,
      "group_led3_stage_ch3": true
    },
    "thumb": "data:image/jpeg;base64,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"
  },
  {
    "name": "Back LED[Ch3]",
    "val": {
      "group_dj_booth": true,
      "group_booth_wa": false,
      "group_booth_led": false,
      "group_booth_led_ch3": true,
      "group_stage": true,
      "group_BackStage": false,
      "group_BackStage_ch3": true,
      "group_led3": false,
      "group_led3_ch3": false,
      "group_led3_front": false,
      "group_led3_back": false,
      "group_led3_stage": false,
      "group_led3_front_ch3": false,
      "group_led3_back_ch3": true,
      "group_led3_stage_ch3": false
    },
    "thumb": "data:image/jpeg;base64,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"
  },
  {
    "name": "Front LED[Ch3]",
    "val": {
      "group_dj_booth": true,
      "group_booth_wa": false,
      "group_booth_led": false,
      "group_booth_led_ch3": false,
      "group_stage": true,
      "group_BackStage": false,
      "group_BackStage_ch3": true,
      "group_led3": false,
      "group_led3_ch3": false,
      "group_led3_front": false,
      "group_led3_back": false,
      "group_led3_stage": false,
      "group_led3_front_ch3": true,
      "group_led3_back_ch3": false,
      "group_led3_stage_ch3": false
    },
    "thumb": "data:image/jpeg;base64,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"
  },
  {
    "name": "Full LED[Ch3]",
    "val": {
      "group_dj_booth": true,
      "group_booth_wa": false,
      "group_booth_led": false,
      "group_booth_led_ch3": true,
      "group_stage": true,
      "group_BackStage": false,
      "group_BackStage_ch3": true,
      "group_led3": false,
      "group_led3_ch3": true,
      "group_led3_front": false,
      "group_led3_back": false,
      "group_led3_stage": false,
      "group_led3_front_ch3": false,
      "group_led3_back_ch3": false,
      "group_led3_stage_ch3": false
    },
    "thumb": "data:image/jpeg;base64,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"
  }
];
//
//
// //gui.add({'open':( ()=>{op()})}, 'open');
//
// //

const groups = [];
var images = {};
var preset = {
  "color1ColorEffectA":new THREE.TextureLoader().load('/Resources/material,color1,Color1.png'),
  "color2ColorEffectA":new THREE.TextureLoader().load('/Resources/material,color2,Color1.png'),
  "color3ColorEffectA":new THREE.TextureLoader().load('/Resources/material,color3,Color1.png'),
  "color1ColorEffectB":new THREE.TextureLoader().load('/Resources/material,color1,Color2.png'),
  "color2ColorEffectB":new THREE.TextureLoader().load('/Resources/material,color2,Color2.png'),
  "color3ColorEffectB":new THREE.TextureLoader().load('/Resources/material,color3,Color2.png'),
  "color1ColorEffectC":new THREE.TextureLoader().load('/Resources/material,color1,Color3.png'),
  "color2ColorEffectC":new THREE.TextureLoader().load('/Resources/material,color2,Color3.png'),
  "color3ColorEffectC":new THREE.TextureLoader().load('/Resources/material,color3,Color3.png'),
}
var presetOptions = Object.keys(preset);

var videos = {
// "vj1":'Free Footage - VJ Loops - Dark 4 - FullHD.mp4',
// "vj2":'Free HD VJ Loops By Rubix.mp4',
// "vj3":'free vj loop stripy HD.mp4',
// "vj4":'Gold Stars and Moons Background  Motion Graphics - Videohive template.mp4',
// "vj5":'Mosaic Corridor  Motion Graphics - Videohive template.mp4',
// "vj6":'twisted hall.mp4',
// "laser":'laser360all_720p.w1280.mp4',
// "spot1": 'spot360_5.w1280.mp4',
// "spot2": 'spot360_6.w1280.mp4',
// "cg": 'tunnel_22.w1280.mp4',
// "2.5D1": 'vlc-record-2018-02-24-16h23m05s-R0010106_er.MP4-.mp4',
// "2.5D2": 'vlc-record-2018-02-24-16h23m49s-R0010106_er.MP4-.mp4',
// "2.5D3": 'vlc-record-2018-02-24-16h24m25s-R0010106_er.MP4-.mp4',
// "dj":'Snap.mp4',
// "dj1":'vlc-record-2018-02-25-13h25m30s-DJ Ritchie Ruftone 6mins online greenscreen.VIEWCOPY.mov.mp4-.mp4',
// "dj2":'vlc-record-2018-02-25-13h26m50s-Chroma Key DJ Chorma Key.mp4',
// "dj3":'vlc-record-2018-02-26-23h27m28s-Bass House Continuous Mix Spring 2017  Zero Chill Green Screen DJ Mix Show Ep. 3 May 15 2017.mp4-.mp4',
// "None":"",
// "Black":"black",
"0WebCam":"webCam",
"0remoteCamera":"remoteCamera",
"0DisplayCapture":"displayCapture",
"0renderTexture":"RenderTexture",
// "text.mp4":"/Resources/movies/text.mp4",
// "RenderTexture":"RenderTexture",
}

var chs = [
      ["effect1","effect"," 1"],
      ["effect2","effect"," 2"],
      ["effect3","effect"," 3"],
      ["effect4","effect"," 4"],
      ["mix1","mix"," 1"],
      ["mix2","mix"," 2"],
      ["mix3","mix"," 3"],
      ["mix4","mix"," 4"],
      ["material1","material"," 1","1"],
      ["material2","material"," 2","2"],
      ["material3","material"," 3","3"],
      ["material4","material"," 4","4"],
      ["material5","material"," 5","5"],
      // ["material3","material"," 3","3"],
      ["mix5","mix"," 5"],
      ["mix6","mix"," 6"],
      ["mix7","mix"," 7"],
      ["mix8","mix"," 8"],
      ["mixquad1","mix","quad1"],
      ["mixquad2","mix","quad2"],
      ["mixflipV","mix","flipV"],
      ["mixflipH","mix","flipH"],
      ["effect5","effect"," 5"],
      ["effect6","effect"," 6"],
      ["effect7","effect"," 7"],
      ["effect8","effect"," 8"],
      ["effectquad1","effect","quad1"],
      ["effectquad2","effect","quad2"],
      ["effectflipV","effect","flipV"],
      ["effectflipH","effect","flipH"]
    ]

const m_dummy = {
  "material1":[3,THREE.DoubleSide,FX_SCENE],
  "material2":[4,THREE.DoubleSide,FX_SCENE],
  "material3":[43,THREE.DoubleSide,DUMMY_SCENE],
  "material4":[44,THREE.DoubleSide,DUMMY_SCENE],
  "material5":[45,THREE.DoubleSide,DUMMY_SCENE],
}

const def = {
 "material": ["caputer","system"],
 "ink": 0,
 "fader": 0,
 "blend": 1,
 "width": 1,
 "height": 1,
 "depth": 1,
 "flipH": 0,
 "flipV": 0,
 "rotation": 0,
 "rotationX": 0,
 "rotationY": 0,
 "locH": 0,
 "locV": 0,
 "locZ": 0,
 "movieRate": 1,
 "currentTime": -1,
}

const matdef = {
 "material": ["material","1"],
 "ink": 0,
 // "fader": {"adjust":1},
 "blend": 1,
 "width": 1,
 "height": 1,
 "depth": 1,
 "flipH": 0,
 "flipV": 0,
 "rotation": 0,
 "rotationX": 0,
 "rotationY": 0,
 "locH": 0,
 "locV": 0,
 "locZ": 0,
 "movieRate": 1,
 "currentTime": -1,
}

const dfaultDistance = 100

var defCtrl = {};
var defDat = {"effect":{},"mix":{},"material":{},};

var snap = {
  init:{
    // build:{
    //   "BackStageA": {
    //     "layer":BLOOM_IGNOR,
    //     "Geometry": "Sphere",
    //     "renderOrder":-2,
    //     "widthSegments": [0, 60],
    //     "heightSegments": [0, 40]
    //   },
    //   // "BackStageB": {
    //   //   "Geometry": "Sphere",
    //   //   "renderOrder":-1,
    //   //   "radius": [0, 500],
    //   //   "widthSegments": [0, 60],
    //   //   "heightSegments": [0, 40]
    //   // },
    //   // "BackStageC": {
    //   //   "Geometry": "Sphere",
    //   //   "renderOrder":-1,
    //   //   "radius": [0, 500],
    //   //   "widthSegments": [0, 60],
    //   //   "heightSegments": [0, 40]
    //   // },
    //   // "BackStageD": {
    //   //   "Geometry": "Sphere",
    //   //   "renderOrder":-1,
    //   //   "radius": [0, 500],
    //   //   "widthSegments": [0, 60],
    //   //   "heightSegments": [0, 40]
    //   // },
    //   // "FrontStageA": {
    //   //   "layer":BLOOM_IGNOR,
    //   //   "Geometry": "Plane",
    //   //   "width": [0, 1000],
    //   //   "height": [0, 1000]
    //   // },
    //   // "FrontStageB": {
    //   //   "layer":BLOOM_IGNOR,
    //   //   "Geometry": "Plane",
    //   //   "width": [0, 1000],
    //   //   "height": [0, 1000]
    //   // },
    //   // "FrontStageC": {
    //   //   "layer":BLOOM_IGNOR,
    //   //   "Geometry": "Plane",
    //   //   "width": [0, 1000],
    //   //   "height": [0, 1000]
    //   // },
    //   // "FrontStageD": {
    //   //   "layer":BLOOM_IGNOR,
    //   //   "Geometry": "Plane",
    //   //   "width": [0, 1000],
    //   //   "height": [0, 1000]
    //   // },
    //   "DJ BoothA": {
    //     "layer":BLOOM_IGNOR,
    //     "Geometry": "Box",
    //   },
    //   // "DJ BoothB": {
    //   //   "layer":BLOOM_SCENE,
    //   //   "Geometry": "Box",
    //   //   "width": [0, 300],
    //   //   "height": [0, 300],
    //   //   "depth": [0, 300]
    //   // },
    //   "DJ": {
    //     "layer":ENTIRE_SCENE,
    //     "Geometry": "Plane",
    //   },
    //   "LED1": {
    //     "renderOrder":1,
    //     "layer":BLOOM_SCENE,
    //     "Geometry": "Plane",
    //   },
    //   "LED2": {
    //     "layer":BLOOM_SCENE,
    //     "Geometry": "Plane",
    //     "renderOrder":-1,
    //   },
    //   "LED3": {
    //     "layer":BLOOM_SCENE,
    //     "Geometry": "Plane",
    //     "renderOrder":-1,
    //   },
    //   "LED4": {
    //     "layer":BLOOM_SCENE,
    //     "Geometry": "Plane",
    //     "renderOrder":-1,
    //   },
    //   // "effect1": {
    //   //   "layer":BLOOM_SCENE,
    //   //   "Geometry": "Plane",
    //   //   "width": [0, 1280],
    //   //   "height": [0, 720]
    //   // },
    // },
    // val:{
    //   thumbs:{},
    //   "BackStageA": {
    //     // "ch": "chABCD",
    //     "ch": "mat_material 3",
    //     "width": -400,
    //     "height": 400,
    //     "depth": 400,
    //     "widthSegments": 60,
    //     "heightSegments": 40,
    //     "RotY": -1.57,
    //     // "opacity": 1,
    //   },
    //   // "BackStageB": {
    //   //   "ch": "chB Basic",
    //   //   "Geometry": "Sphere",
    //   //   "radius": 148.8724453840733,
    //   // },
    //   // "BackStageC": {
    //   //   "ch": "chC Basic",
    //   //   "Geometry": "Sphere",
    //   //   "radius": 148.8724453840733,
    //   // },
    //   // "BackStageD": {
    //   //   "ch": "chD Basic",
    //   //   "Geometry": "Sphere",
    //   //   "radius": 148.8724453840733,
    //   // },
    //   "DJ BoothA": {
    //     // "ch": "mat_material 2",
    //     "ch": "Black",
    //     "Geometry": "Box",
    //     "width": 160,
    //     "height": 140,
    //     "depth": 50,
    //     "PosX": 0,
    //     "PosY": -110,
    //     // "RotY": 1.5,
    //   },
    //   // "DJ BoothB": {
    //   //   "ch": "chB Basic",
    //   //   "Geometry": "Box",
    //   //   "width": 84.05996898156127,
    //   //   "height": 75.79281183932346,
    //   //   "depth": 75.79281183932346,
    //   //   "PosX": -13.107822410148003,
    //   //   "PosY": -67.23044397463002,
    //   //   "RotY": 1.5,
    //   // },
    //   // "FrontStageA": {
    //   //   "ch": "chA Add",
    //   //   "Geometry": "Plane",
    //   //   "width": 622.0920213682579,
    //   //   "height": 655.1783560227469,
    //   //   "PosX": 46.78614509736343,
    //   //   "RotY": 1.5,
    //   // },
    //   // "FrontStageB": {
    //   //   "ch": "chB Add",
    //   //   "Geometry": "Plane",
    //   //   "width": 622.0920213682579,
    //   //   "height": 655.1783560227469,
    //   //   "PosX": 46.78614509736343,
    //   //   "RotY": 1.5,
    //   // },
    //   // "FrontStageC": {
    //   //   "ch": "chC Add",
    //   //   "Geometry": "Plane",
    //   //   "width": 622.0920213682579,
    //   //   "height": 655.1783560227469,
    //   //   "PosX": 46.78614509736343,
    //   //   "RotY": 1.5,
    //   // },
    //   // "FrontStageD": {
    //   //   "ch": "chD Add",
    //   //   "Geometry": "Plane",
    //   //   "width": 622.0920213682579,
    //   //   "height": 655.1783560227469,
    //   //   "PosX": 46.78614509736343,
    //   //   "RotY": 1.5,
    //   // },
    //   "DJ": {
    //     // "ch": "chDJ",
    //     "ch": "mat_material 5 Key",
    //     "Geometry": "Plane",
    //     "width": 130,
    //     "height": 80,
    //     "PosX": 0,
    //     "PosY": 0,
    //     // "RotY": 1.6,
    //   },
    //   "LED1": {
    //       // "ch": "chCD Add",
    //       "ch": "mat_material 4 Add",
    //       "width": 160,
    //       "height": 90,
    //       "PosX": 0,
    //       "PosY": -75,
    //       "PosZ": 30,
    //       "RotX": 0,
    //       // "RotY": 1.4926004228329806,
    //   },
    //   "LED2": {
    //       // "ch": "chCD Add LED",
    //       "ch": "mat_material 4 Add",
    //       "width": 200,
    //       "height": 112,
    //       "PosX": -300,
    //       "PosY": 150,
    //       "PosZ": -50,
    //       "RotY": 1.57,
    //   },
    //   "LED3": {
    //       // "ch": "chCD Add LED",
    //       "ch": "mat_material 4 Add",
    //       "width": 250,
    //       "height": 140,
    //       "PosX": 0,
    //       "PosY": 150,
    //       "PosZ": -150,
    //       // "RotY": -1.5,
    //   },
    //   "LED4": {
    //     "ch": "mat_material 4 Add",
    //     // "ch": "chCD Add LED",
    //     "width": 200,
    //     "height": 112,
    //     "PosX": 300,
    //     "PosY": 150,
    //     "PosZ": -50,
    //     "RotY": -1.57,
    //   },
    //   // "chDJ": {
    //   //     "ChromaKey": 5242752,
    //   //     "ChromaKey_saturation": -0.7306208347948089,
    //   //     "ChromaKey_brightness": -0.5510347246580147,
    //   //     "ChromaKey_contrast": -0.10206944931602946,
    //   //     "opacity_chDJ": 1,
    //   //   },
    //   // "effect1": {
    //   //     "ch": "chCD Add",
    //   //     "width": 618,
    //   //     "height": 348,
    //   //     "PosX": 0,
    //   //     "PosY": 0,
    //   //     "PosZ": 0,
    //   //     "RotX": 0,
    //   //     // "RotY": 1.5,
    //   // },
    //  "cut0start": {
    //       "PosX": -15.126050420168099,
    //       "PosY": 26.96382900986481,
    //       "PosZ": 0,
    //       "lat": 51.36645962732919,
    //       "lon": 0,
    //       "distance": 26.96382900986481,
    //       "RotZ": 0
    //   },
    //   "cut0end": {
    //       "PosX": 5.918889294848384,
    //       "PosY": 19.948849104859335,
    //       "PosZ": 0,
    //       "lat": 51.36645962732919,
    //       "lon": 0,
    //       "distance": 26.96382900986481,
    //       "RotZ": 0
    //   },
    //   "cut1start": {
    //       "PosX": 0,
    //       "PosY": 0,
    //       "PosZ": 0,
    //       "lat": 0,
    //       "lon": 0,
    //       "distance": 55.02374862988671,
    //       "RotZ": 0
    //   },
    //   "cut1end": {
    //       "PosX": 0,
    //       "PosY": 0,
    //       "PosZ": 0,
    //       "lat": 5.652173913043484,
    //       "lon": 0,
    //       "distance": 40.99378881987576,
    //       "RotZ": 0
    //   },
    //   "cut2start": {
    //       "PosX": -1.0960906101570913,
    //       "PosY": 5.918889294848384,
    //       "PosZ": -15.126050420168099,
    //       "lat": 0,
    //       "lon": 16.17829740591887,
    //       "distance": 40.99378881987576,
    //       "RotZ": 0
    //   },
    //   "cut2end": {
    //       "PosX": -1.0960906101570913,
    //       "PosY": -1.0960906101570913,
    //       "PosZ": 26.96382900986481,
    //       "lat": 3.6645962732919344,
    //       "lon": -17.493606138107424,
    //       "distance": 40.99378881987576,
    //       "RotZ": 0
    //   },
    //   "cut3start": {
    //       "PosX": 0,
    //       "PosY": -15.126050420168099,
    //       "PosZ": 0,
    //       "lat": -32.11180124223603,
    //       "lon": 0,
    //       "distance": 33.97880891487034,
    //       "RotZ": 0
    //   },
    //   "cut3end": {
    //       "PosX": 0,
    //       "PosY": 19.948849104859335,
    //       "PosZ": 0,
    //       "lat": 33.478260869565204,
    //       "lon": -0.6576543660942491,
    //       "distance": 48.008768724881236,
    //       "RotZ": 0
    //   },
    //   "cut4start": {
    //       "PosX": 0,
    //       "PosY": 0,
    //       "PosZ": 0,
    //       "lat": 0,
    //       "lon": 0,
    //       "distance": 125.17354767994158,
    //       "RotZ": 0
    //   },
    //   "cut4end": {
    //       "PosX": 0,
    //       "PosY": 0,
    //       "PosZ": 0,
    //       "lat": 0,
    //       "lon": 0,
    //       "distance": 26.96382900986481,
    //       "RotZ": 0
    //   },
    //   "cut5start": {
    //       "PosX": 0,
    //       "PosY": 0,
    //       "PosZ": 0,
    //       "lat": 0,
    //       "lon": 0,
    //       "distance": 40.99378881987576,
    //       "RotZ": 0
    //   },
    //   "cut5end": {
    //       "PosX": 0,
    //       "PosY": 0,
    //       "PosZ": 0,
    //       "lat": 0,
    //       "lon": 3.5513335769090304,
    //       "distance": 167.26342710997443,
    //       "RotZ": 0
    //   },
    //   "cut6start": {
    //       "PosX": 0,
    //       "PosY": -15.126050420168099,
    //       "PosZ": 0,
    //       "lat": -2.298136645962728,
    //       "lon": -51.16550968213372,
    //       "distance": 139.20350748995247,
    //       "RotZ": 0
    //   },
    //   "cut6end": {
    //       "PosX": 0,
    //       "PosY": 76.06868834490314,
    //       "PosZ": 0,
    //       "lat": 0,
    //       "lon": 49.85020094994519,
    //       "distance": 153.23346729996348,
    //       "RotZ": 0
    //   },
    //   "cut7start": {
    //       "PosX": 0,
    //       "PosY": 69.05370843989766,
    //       "PosZ": 0,
    //       "lat": -24.161490683229815,
    //       "lon": 33.014249177932015,
    //       "distance": 139.20350748995247,
    //       "RotZ": 0
    //   },
    //   "cut7end": {
    //       "PosX": 0,
    //       "PosY": -57.21592985020095,
    //       "PosZ": 0,
    //       "lat": 17.577639751552795,
    //       "lon": -42.74753379612716,
    //       "distance": 146.218487394958,
    //       "RotZ": 0
    //   },
    //   "cut8start": {
    //       "PosX": 0,
    //       "PosY": 0,
    //       "PosZ": 12.93386919985386,
    //       "lat": 0,
    //       "lon": 0,
    //       "distance": 104.1286079649251,
    //       "RotZ": 0
    //   },
    //   "cut8end": {
    //       "PosX": 0,
    //       "PosY": 0,
    //       "PosZ": -22.141030325173517,
    //       "lat": 0,
    //       "lon": 0,
    //       "distance": 132.188527584947,
    //       "RotZ": 0
    //   },
    //   "cut9start": {
    //       "PosX": 0,
    //       "PosY": 0,
    //       "PosZ": 0,
    //       "lat": -24.161490683229815,
    //       "lon": 0,
    //       "distance": 76.06868834490314,
    //       "RotZ": 0
    //   },
    //   "cut9end": {
    //       "PosX": 0,
    //       "PosY": 0,
    //       "PosZ": 0,
    //       "lat": 27.515527950310556,
    //       "lon": 0,
    //       "distance": 146.218487394958,
    //       "RotZ": 0
    //   },
    //   "cut10start": {
    //       "PosX": 0,
    //       "PosY": 0,
    //       "PosZ": 0,
    //       "lat": 0,
    //       "lon": 0,
    //       "distance": dfaultDistance,
    //       "RotZ": 0
    //   },
    //   "cut10end": {
    //       "PosX": 0,
    //       "PosY": 0,
    //       "PosZ": 0,
    //       "lat": 0,
    //       "lon": 0,
    //       "distance": dfaultDistance,
    //       "RotZ": 0
    //   },
    // }
    //
    build:{},
    val:{thumbs:{}}
  }
};

wrapInitVals(snap.init.val,snap.init);

chs.forEach((key,index) => {

 //初期化 一度stringifyを通して、インスタンスかを解除
 if(key[1] == "material"){
   defDat[key[1]][key[2]] = Utl.jsonCopy(matdef);//JSON.parse(JSON.stringify(matdef));
   defDat[key[1]][key[2]].material[1] = key[3]
   // if(key[2]==" 3") defDat[key[1]][key[2]].fader = 1;

 }else{
   defDat[key[1]][key[2]] = Utl.jsonCopy(def);//JSON.parse(JSON.stringify(def));
 }
 // console.log(key[0]);
 // console.log(defDat[key[1]][key[2]]);

 snap.init.build["mesh_"+key[1]+key[2]] = {
     "layer":FX_SCENE,
     "renderOrder":10+index,
     "Geometry": "Plane",
     // "width": [0, 1280],
     // "height": [0, 720]
   }

 if(m_dummy[key[0]])snap.init.build["mesh_"+key[1]+key[2]].layer = m_dummy[key[0]][2];

 // snap.init.val["mesh_"+key[1]+key[2]] = {
 //    "ch": key[1]+key[2],
 //    "width": width,
 //    "height": height,
 //    "PosX": 0,
 //    "PosY": 0,
 //    "PosZ": 0,
 //    "RotX": 0,
 //      // "RotY": 1.5,
 //  }
})

// "ChromaKey": 5242752,
// "ChromaKey_hue": 0,
// "ChromaKey_saturation": -0.7306208347948089,
// "ChromaKey_brightness": -0.5510347246580147,
// "ChromaKey_contrast": -0.10206944931602946,



// const result = {};
// var entries;
let handle;
// let file;
// var fileHandles = [];
var confJsonhandle;
// var confJson = {thumbs:{},data:{}};
// var meshs = {};

var videosFile = {};
// var imagesFile = {};

// var tool = {};
// var gui;
var materials2 = {};
var darkMaterial = new THREE.MeshBasicMaterial( { color: "black" } );

// var OBJ;
var Dp = {cameraObjs:[],mixers:[],imagesFile:[]};

Dp.rtfxFunc = (rtfx) => {
  if(TimeBase.tweens.fx) delete TimeBase.tweens.fx;
  Dp.drag = rtfx;
  Dp.dragStartTime = Date.now();
  var dat = rtfx.rtfx.data;
  Dp.channel.postMessage({massage:"setFx",param:dat.down,opt:{adjust:1,type:"down"}});//opt1:1,opt2:"down"});
  //fx.func(dat.down,1,"down");
  var mousemove = (e)=>{
    const target = Dp.drag.pos;
    const pos = {x:-(target.x - e.clientX),y:-(target.y - e.clientY)};
    const d = -Math.sqrt(pos.x * pos.x + pos.y * pos.y);
    const r = (Math.atan2(pos.x,pos.y) * 0.5) - 0.5;
    const rev = 3;

    if(dat.d) Dp.channel.postMessage({massage:"setFx",param:dat.d,opt:{adjust:d/40,type:"d"}}) //fx.func(dat.d,d/40,"d");
    if(dat.r) Dp.channel.postMessage({massage:"setFx",param:dat.r,opt:{adjust:r,type:"r"}}) //fx.func(dat.r,r,"r");
    if(dat.xd)Dp.channel.postMessage({massage:"setFx",param:dat.xd,opt:{adjust:-pos.x/rev,type:"xd"}}) //fx.func(dat.xd,-pos.x/rev,"xd");
    if(dat.yd)Dp.channel.postMessage({massage:"setFx",param:dat.yd,opt:{adjust:pos.y/rev,type:"yd"}}) //fx.func(dat.yd,pos.y/rev,"yd");
    if(dat.x) Dp.channel.postMessage({massage:"setFx",param:dat.x,opt:{adjust:pos.x/rev,type:"y"}}) //fx.func(dat.x,pos.x/rev,"y");
    if(dat.y) Dp.channel.postMessage({massage:"setFx",param:dat.y,opt:{adjust:pos.y/rev,type:"y"}}) //fx.func(dat.y,pos.y/rev,"y");

    // console.log([pos,d,r]);
  };

  var mouseup = (e)=>{
    var pow = Date.now() - Dp.dragStartTime;
    if(pow < 1000*2){
      Object.values(dat.down.effect).forEach(fx => {
        if(typeof fx.fader == "number") fx.fader = {adjust:fx.fader};
        else if(typeof fx.fader == "undefined") fx.fader = {adjust:1};
        // console.log(fx.fader)
        // console.log(typeof fx.fader)
        // console.log(fx)
      })
      // console.log(dat.down.effect)

      Dp.channel.postMessage({
        massage:"setFx",
        // param:{"effect":defDat.effect},
        param:dat.down,
        opt:{tweenInit:true,start:Date.now(),tween:pow,type:"clear"}

        // tw.opt.adjust = (Date.now() - tw.opt.start) / tw.opt.tween;
        // if(tw.opt.adjust > 1){
        //   tw.opt.adjust = 1;
        //   delete TimeBase.tweens[key];
        // }
        // if(tw.opt.del) tw.opt.adjust = (1-tw.opt.adjust);
        // tw.func(tw.param,tw.opt);

      });
    }

    // fx.func({"effect":defDat.effect},0,"clear");
    // console.log("up")
    window.removeEventListener("mousemove", mousemove , false);
    window.removeEventListener("mouseup", mouseup , false);
    Dp.drag = null;
  };

  window.addEventListener("mousemove" , mousemove);
  window.addEventListener("mouseup" , mouseup);

  // Dp.paramFunc();
}


export default function(){//obj){
  //
  // Utl.Dp = Dp;
  // OBJ = obj;
  Utl.Dp = Dp;
  Dp.openPj = openPj;
  Dp.openSample = openSample;
  Dp.initPj = initPj;
  Dp.fx = fx;
  Dp.mov = mov;
  Dp.snap = snap;
  Dp.fullscreenOff = async()=>{
    Utl.AxiosWrap.get("/fullscreenOff");
    Dp.channel.postMessage({massage:"closeSub"});
    // OBJ.setState("loaded")}
  };
  Dp.setVideo = async (video,file)=>{
    // 動画を読み込む
    if(videosFile[file]){
      var a = await getmp4(file)
      video.src = URL.createObjectURL(a);

    }else {
      video.src = file;
    }
  };

  // Dp.initBuild = ()=>{
  //   for (let [key, value] of Object.entries(snap.init.val)) {
  //       for (let [key2, value2] of Object.entries(value)) {
  //           // console.log(key,key2);
  //           if(snap.val[key]) snap.val[key][key2] = value2;
  //           if(snap.obj[key]){
  //             // console.log(key,key2,value2,snap.obj[key]);
  //             if(typeof snap.obj[key][key2] === 'function') snap.obj[key][key2](value2);
  //             else snap.obj[key][key2] = value2
  //           }
  //       }
  //   }
  // };

  Dp.buildBlob = ()=>{
    snap.val.info = Utl.CONF.info;
    return new Blob([JSON.stringify(snap.val, null, '  ')],{type: 'application/json'});
  }

  function settingClose(){
    Dp.HeaderMenu.close()
    Dp.overWrightFile()
  }

      const oprnUrl = {
        title:"WEBを開く",
        click:()=>{
          // var list = Utl.CookiesGet('urls');//((document.cookie + ';').match('designpad=([^¥S;]*)')||[])[1];
          // if(list)list = JSON.parse(decodeURIComponent(list));
          // else list = [""];

          console.log(snap.val.oprnUrl)
          if(!Array.isArray(snap.val.oprnUrl) || !snap.val.oprnUrl) snap.val.oprnUrl = [""];
          else if(snap.val.oprnUrl[0]!="")snap.val.oprnUrl.unshift("");
          var list = snap.val.oprnUrl;

          function updateMenu(list){
            // Dp.HeaderMenu.setDialog([]);
            Dp.HeaderMenu.setDialog(buildMenu(list));
          }

          // Dp.setDialog = (title,list)=>{
          //   Dp.HeaderMenu.open(
          //     [
          //       title,
          //       buildGui(list),
          //       Dp.HeaderMenu.close(),
          //       "Close"
          //     ]);
          // }

          function buildMenu(list){
            return [
              "URLを入力してください。",
              list.map((url,key)=>(
                <ListItem key={"inputBase"+"Web"+(list.length - key)+Math.random()}>
                  {key == 0 ?
                  <InputBase
                   id={"inputBase"+"Web"+(list.length - key)}
                   placeholder={"https://"}
                   inputProps={{ 'aria-label': 'search google maps','defaultValue': url}}
                 />
                 :
                 <InputBase
                  disabled
                  id={"inputBase"+"Web"+(list.length - key)}
                  placeholder={"Web"+(list.length - key)+" https://"}
                  inputProps={{ 'aria-label': 'search google maps','defaultValue': url}}
                />
                 }
                 <IconButton type="submit" title="Open" onClick={async ()=>{
                   if(document.getElementById('inputBaseWeb'+(list.length - key)).value == "") return
                   url = await Utl.ctrlWindow({id:"Web"+(list.length - key),visible:"show"})
                   if(url != "" && key == 0){
                       list[0] = url;
                       snap.val.oprnUrl.unshift("");

                       Dp.overWrightFile();
                       // document.cookie = 'designpad=' + encodeURIComponent(JSON.stringify(list)) + "; max-age=" + 60*60*24*10;
                       // Dp.HeaderMenu.setDialog(buildMenu(list));
                       updateMenu(list);
                   }
                 }}>
                   <SearchIcon />
                 </IconButton>
                 {key == 0 ? "":
                   <IconButton type="submit" title="Close" onClick={()=>{
                     url = Utl.ctrlWindow({id:"Web"+(list.length - key),visible:"close"})
                   }}>
                     <VisibilityOffIcon />
                   </IconButton>
                 }
                 {key == 0 ? "":
                   <IconButton type="submit" title="Delete" onClick={()=>{
                     list.splice(key, 1)
                     Dp.overWrightFile();
                     // document.cookie = 'designpad=' + encodeURIComponent(JSON.stringify(list)) + "; max-age=" + 60*60*24*10;
                     updateMenu(list);//Dp.HeaderMenu.setDialog(buildMenu(list))
                     // Dp.HeaderMenu.close();
                     // Utl.ctrlWindow({id:"Web"+(list.length - key),visible:"hide",type:"win"})
                   }}>
                     <DeleteIcon />
                   </IconButton>
                 }
               </ListItem>
             )),
             ()=>{
               Dp.HeaderMenu.close()
               Dp.overWrightFile()//Utl.CookiesGet('urls')
               Utl.ctrlWindow({visible:"hide"})
             },
             "Close"
            ]
          }
          Dp.HeaderMenu.open(buildMenu(list));
        }
      }



      const editBanks = {
        title:"バンクを開く",
        click:()=>{

          console.log(snap.val.banks)
          const iniBnk = {name:"",val:{}};

          if(!Array.isArray(snap.val.banks) || !snap.val.banks) snap.val.banks = [{...iniBnk}];
          // else if(snap.val.banks[0]!="")snap.val.banks.unshift({});
          var list = snap.val.banks;

          function updateMenu(list){
            // Dp.HeaderMenu.setDialog([]);
            Dp.HeaderMenu.setDialog(buildMenu(list));
          }

          // Dp.setDialog = (title,list)=>{
          //   Dp.HeaderMenu.open(
          //     [
          //       title,
          //       buildGui(list),
          //       Dp.HeaderMenu.close(),
          //       "Close"
          //     ]);
          // }

          function buildMenu(list){
            return [
              "バンク編集",
              list.map((url,key)=>(
                <ListItem key={"inputBase"+"Web"+(list.length - key)+Math.random()}>
                  {key == 0 ?
                  <InputBase
                   id={"inputBase"+"Web"+(list.length - key)}
                   placeholder={"新規バンク名称"}
                   inputProps={{ 'aria-label': 'search google maps','defaultValue': url.name}}
                 />
                 :
                 <InputBase
                  disabled
                  id={"inputBase"+"Web"+(list.length - key)}
                  placeholder={"Web"+(list.length - key)+" https://"}
                  inputProps={{ 'aria-label': 'search google maps','defaultValue': url.name}}
                />
                 }

                 {/*
                 <IconButton type="submit" title="Open" onClick={()=>{
                   // url = Utl.ctrlWindow({id:"Web"+(list.length - key),visible:"show"})
                   if(url.name != "" && key == 0){
                       list[0] = url;
                       list.unshift("");

                       Dp.overWrightFile();
                       // document.cookie = 'designpad=' + encodeURIComponent(JSON.stringify(list)) + "; max-age=" + 60*60*24*10;
                       // Dp.HeaderMenu.setDialog(buildMenu(list));
                       updateMenu(list);
                   }
                 }}>
                   <SearchIcon />
                 </IconButton>
                 */}

                 {key == 0 ?
                   <IconButton type="submit" title="Add" onClick={()=>{
                     if(document.getElementById('inputBaseWeb'+(list.length - key)).value == "") return
                     // url = Utl.ctrlWindow({id:"Web"+(list.length - key),visible:"close"})
                     for (let [key, value] of Object.entries(snap.val.addBanks)) {
                       if(value){
                         const keys = key.split("/");
                         if(key == "groups"){
                           groups.forEach(gnm => {
                             list[0].val[gnm] = Utl.jsonCopy(snap.val[gnm]);
                           })

                         }else if(keys.length == 1){
                           list[0].val[key] = Utl.jsonCopy(snap.val[key]);

                         }else if(keys.length == 2){
                           if(!list[0].val[keys[0]])list[0].val[keys[0]] = {};
                           list[0].val[keys[0]][keys[1]] = Utl.jsonCopy(snap.val[keys[0]][keys[1]]);

                         }else if(keys.length == 3){
                           if(!list[0].val[keys[0]])list[0].val[keys[0]] = {};
                           if(!list[0].val[keys[0]][keys[1]])list[0].val[keys[0]][keys[1]] = {};
                           list[0].val[keys[0]][keys[1]][keys[2]] = Utl.jsonCopy(snap.val[keys[0]][keys[1]][keys[2]]);
                         }
                       }
                     }

                     list[0].name = document.getElementById('inputBase'+"Web"+(list.length - key)).value
                     list[0] = {...list[0]};

                     //
                     // "TimeBase/bpm":false,
                     // "bloomExposure":false,
                     // "bloomRadius":false,
                     // "bloomStrength":false,
                     // "bloomThreshold":false,
                     // "material 5/ChromaKey":false,
                     // "material 5/ChromaKey_hue":false,
                     // "material 5/ChromaKey_saturation":false,
                     // "material 5/ChromaKey_brightness":false,
                     // "material 5/ChromaKey_contrast":false,
                     // "cuts/mode":false,
                     // "cuts/type":false,
                     // "groups":true,
                     // "currentFx":false,
                     // "currentMov/chA":false,
                     // "currentMov/chB":false,
                     // "currentMov/chC":false,
                     // "currentMov/chDJ":false,

                     Dp.canvasCapture = document.createElement('canvas');
                     Dp.canvasCapture.width = 40*2;//video.videoWidth
                     Dp.canvasCapture.height = 29*2;//video.videoHeight

                     // list[0] = url;
                     list.unshift({...iniBnk});

                     Dp.overWrightFile();
                     // document.cookie = 'designpad=' + encodeURIComponent(JSON.stringify(list)) + "; max-age=" + 60*60*24*10;
                     // Dp.HeaderMenu.setDialog(buildMenu(list));
                     updateMenu(list);
                   }}>
                     <AddIcon />
                   </IconButton>
                   :""
                 }
                 {key == 0 ? "":
                   <IconButton type="submit" title="Play" onClick={()=>{
                     // url = Utl.ctrlWindow({id:"Web"+(list.length - key),visible:"close"})
                     // const tgt = document.getElementById('inputBase'+"Web"+(list.length - key)).value;
                     // const val = list.find( ({ name }) => name === tgt );
                     banks.func(list[key].val);
                     console.log(list[key]);
                   }}>
                     <PlayArrowIcon />
                   </IconButton>
                 }
                 {key == 0 ? "":
                   <IconButton type="submit" title="Delete" onClick={()=>{
                     list.splice(key, 1)
                     Dp.OBJ.setBanks(list);

                     Dp.overWrightFile();
                     // document.cookie = 'designpad=' + encodeURIComponent(JSON.stringify(list)) + "; max-age=" + 60*60*24*10;
                     updateMenu(list);//Dp.HeaderMenu.setDialog(buildMenu(list))
                     // Dp.HeaderMenu.close();
                     // Utl.ctrlWindow({id:"Web"+(list.length - key),visible:"hide",type:"win"})
                   }}>
                     <DeleteIcon />
                   </IconButton>
                 }
               </ListItem>
             )),
             ()=>{
               Dp.HeaderMenu.close()
               Dp.overWrightFile()//Utl.CookiesGet('urls')
               Utl.ctrlWindow({visible:"hide"})
             },
             "Close"
            ]
          }
          Dp.HeaderMenu.open(buildMenu(list));
        }
      }



    function buildGui (list){
      return list.map((val,key)=>(
        <ListItem key={val.key}>
          <Grid container spacing={1} text-align={"center"}>
            <Grid item>
              <ListItemText id="switch-list-label-bluetooth" primary={val.key} />
            </Grid>
            <Grid item xs>
            {
              val.type=="number"?
              <TextField
                id={val.key}
                type="number"
                defaultValue={val.val[val.key]}
                onChange={(e)=>{
                  const v = e.target.value;
                  if(val.range[0]>v)e.target.value = val.range[0];
                  if(val.range[1]<v)e.target.value = val.range[1];
                  val.obj[val.key](e.target.value)
                }}
              />
              :""
            }
            {
              val.type=="color"?
              <Color callback = {val.obj[val.key]} def={val.val[val.key]}/>
              :""
            }
            {
              val.type=="boolian"?
              <Switches callback = {val.obj[val.key]} def={val.val[val.key]}/>
              :""
            }
            {
              Array.isArray(val.type)?
              <Selects callback = {val.obj[val.key]} def={val.val[val.key]} list={val.type}/>
              :""
            }
            {
              !val.type?
              <input
                id = {val.key}
                className="range"
                type="range"
                defaultValue={val.val[val.key]}
                onChange={(e)=>{val.obj[val.key](e.target.value)}}
                step="0.01"
                min={val.range[0]}
                max={val.range[1]}
                style={{
                  "position": "relative",
                  "color": "#2196f3",
                  "width": "100%",
                  "cursor": "pointer",
                  "height": "2px",
                  "display": "inline-block",
                  "padding": "11px 0",
                  "position": "relative",
                }}
              />
              :""
            }
            </Grid>
          </Grid>
        </ListItem>
     ))
   }

    const effectSetting = {
      title:"ブルーム設定",
    }

    effectSetting.click = ()=>{
      const scope = [
        {obj:snap.obj,val:snap.val,key:"bloomThreshold",range:[0.0, 2]},
        {obj:snap.obj,val:snap.val,key:"bloomExposure",range:[0.0, 2.0 ]},
        {obj:snap.obj,val:snap.val,key:"bloomStrength",range:[0.0, 6.0 ]},
        {obj:snap.obj,val:snap.val,key:"bloomRadius",range:[0.0, 2.0]},
      ]

      Dp.HeaderMenu.open([
        effectSetting.title,
        buildGui(scope),
        settingClose,
        "Close"
      ]);
    }


     const addBanks = {
       title:"バンク設定",
     }

     addBanks.click = ()=>{
       const scope = [];
       Object.keys(snap.val.addBanks).forEach(key => {
         const obj = {obj:{},val:snap.val.addBanks,key:key,type:"boolian"};
         obj.obj[key] = (v)=>{snap.val.addBanks[key] = v};
         scope.push(obj);
       })

       Dp.HeaderMenu.open([
         addBanks.title,
         buildGui(scope),
         settingClose,
         "Close"
       ]);
     }

     const sceneSetting = {
       title:"シーン設定",
     }

     sceneSetting.click = ()=>{
       const scope = []
       groups.forEach(gnm => {
         scope.push(
           {obj:snap.obj,val:snap.val,key:gnm,type:"boolian"}
         )
       })

       Dp.HeaderMenu.open([
         sceneSetting.title,
         buildGui(scope),
         settingClose,
         "Close"
       ]);
     }


    const motionSetting = {
      title:"アニメーション設定",
    }

    motionSetting.click = ()=>{
      const scope = []
      Object.keys(snap.obj.initVals.currentAnimationsClip).map(
        (key)=>{
          var type = ["stop","playlist","random"];
          if(Dp.animations[key]) type = "boolian";

          scope.push({
              obj:snap.obj.initVals.currentAnimationsClip,
              val:snap.val.initVals.currentAnimations,
              key:key,
              type:type
            });
          }
        );

      Dp.HeaderMenu.open([
        motionSetting.title,
        buildGui(scope),
        settingClose,
        "Close"
      ]);
    }



   const screenSizeSetting = {
     title:"画面設定",
   }

   screenSizeSetting.click = ()=>{
     Dp.HeaderMenu.open([
       screenSizeSetting.title,
       buildGui([
         {
             obj:snap.obj.cuts,
             val:snap.val.cuts,
             key:"dispWidth",
             type:"number",
             range:[0,2000]
           },
           {
               obj:snap.obj.cuts,
               val:snap.val.cuts,
               key:"dispHeight",
               type:"number",
               range:[0,2000]
             },
         {
             obj:snap.obj.cuts,
             val:snap.val.cuts,
             key:"layout",
             type:["1 column","2 column"],
           },
       ]),
       ()=>{
         Dp.OBJ.update(Math.random());
         settingClose();
         snap.obj.initVals.currentFx(snap.val.initVals.currentFx)
       },
       "Close"
     ]);
   }

   const chromaSetting = {
     title:"クロマキー設定",
   }

   chromaSetting.click = ()=>{
     const scope = [
       //{key:"ChromaKey",range:[0.1, 2]},
       {obj:snap.obj["material 5"],val:snap.val["material 5"],key:"ChromaKey",type:"color"},
       {obj:snap.obj["material 5"],val:snap.val["material 5"],key:"ChromaKey_hue",range:[-2,2 ]},
       {obj:snap.obj["material 5"],val:snap.val["material 5"],key:"ChromaKey_saturation",range:[-1,1]},
       {obj:snap.obj["material 5"],val:snap.val["material 5"],key:"ChromaKey_brightness",range:[-1,1]},
       {obj:snap.obj["material 5"],val:snap.val["material 5"],key:"ChromaKey_contrast",range:[-1,1]},
     ]

     Dp.HeaderMenu.open([
       chromaSetting.title,
       buildGui(scope),
       settingClose,
       "Close"
     ]);
   }

   Dp.cameras = [
    [0,"2d","2d","2D表示"],
    [0,"stop","pinponEase","モーション1"],
    [1,"stop","pinponEase","モーション2"],
    [2,"stop","pinponEase","モーション3"],
    [3,"stop","pinpon","モーション4"],
    [4,"stop","pinpon","モーション5"],
    [5,"stop","pinpon","モーション6"],
    [6,"stop","base","モーション7"],
    [7,"stop","base","モーション8"],
    [8,"stop","ease","モーション9"],
    [9,"stop","ease","モーション10"],
    [10,"stop","ease","モーション11"],
    [0,"random","base","ランダム1"],
    [0,"random","pinponEase","ランダム2"],
    [0,"random","ease","ランダム3"],
    [0,"random","pinpon","ランダム4"]
  ];

  const motion = {
              title:"カメラ設定",
              click:()=>{

                Dp.HeaderMenu.open(
                ["カメラモーション",
                Dp.cameras.map((cut)=>(
                  <ListItem button onClick={() => {
                          snap.val.cuts.current = cut[0];
                          snap.val.cuts.mode = cut[1];

                          if(cut[1] == "2d"){
                            snap.val.cuts.type = cut[2];
                            snap.obj.cameraChange(1);

                          }if(cut[0] == "imported"){
                            // snap.val.cuts.current = cut[0];
                            // snap.val.cuts.mode = cut[1];
                            snap.val.cuts.type = [cut[2]];
                            snap.obj.cameraChange(cut[2]);

                          }else if(cut[1] != "2d"){
                            // snap.val.cuts.current = cut[0];
                            // snap.val.cuts.mode = cut[1];
                            snap.val.cuts.type = cut[2];
                            snap.obj.cameraChange(0);
                          }
                          settingClose();
                        }} key={cut[0]+cut[1]+cut[2]}>
                    <ListItemText primary={cut[3]} />
                  </ListItem>
                )),
                settingClose,
                "Close"
              ])}}


  Dp.menu = [
          // {title:"全画面表示",click:()=>{document.getElementById('canvas-frame').requestFullscreen()}},
          // {title:"開発ツール",click:async ()=>{Utl.AxiosWrap.get("/openDevTools");}},
          {title:"フォルダを開く",click:async ()=>{window.location.reload()}},
          oprnUrl,
          editBanks,
          "devider",
          addBanks,
          sceneSetting,
          motionSetting,
          motion,
          effectSetting,
          chromaSetting,
          "devider",
          screenSizeSetting,
          {title:"フルスクリーン表示",click:async ()=>{
            Dp.windowsSize = await Utl.AxiosWrap.get("/fullscreenOn");
            Dp.channel.postMessage({massage:"fullscreenOn"});
            //OBJ.setState("loaded_opensub")
          }},
          "devider",
          {title:"ライセンス",click:async ()=>{
            window.location.href = window.location.origin+"/#/login/cmd/Mypage";
          }},

          // {title:"別画面から操作",click:async()=>{window.open("/#/login/target/sub","win","top=0,width=320,height=480,left=0,location=1,status=0");}},
          // {title:"別画面で表示",click:async()=>{window.open("/#/login/target/screen","win","top=0,width=320,height=480,left=0,location=1,status=0");}},
        ]

  Dp.menu2 = [
          {title:"フォルダを開く",click:async ()=>{window.location.reload()}},
          oprnUrl,
          editBanks,
          "devider",
          addBanks,
          sceneSetting,
          motionSetting,
          motion,
          effectSetting,
          chromaSetting,
          "devider",
          {title:"フルスクリーン表示終了",click:Dp.fullscreenOff},
          // {title:"Web1",click:()=>{Utl.ctrlWindow({id:"Web1",w:0,h:1,type:"iframe"})},input:true},
          // {title:"Web2",click:()=>{Utl.ctrlWindow({id:"Web2",w:1,h:0,type:"iframe"})},input:true},
          // {title:"Web3",click:()=>{Utl.ctrlWindow({id:"Web3",w:1,h:1,type:"iframe"})},input:true},
        ]
        //https://player.twitch.tv/?channel=hotbeatstv&parent=localhost
        //https://player.twitch.tv/?channel=hanawins&parent=localhost

  document.addEventListener('keydown', event => {
      if (event.key == 'Escape'){
        Dp.fullscreenOff();
      }
  });

  return Dp;
}



var initPj = async function(){
  if(!Dp.OBJ.user.data)return

  Dp.OBJ.setState("loading");
  RTFxs = Dp.OBJ.user.data.RTFxs;
  FXs = Dp.OBJ.user.data.ColorFX.concat(Dp.OBJ.user.data.FlashInkFX).concat(Dp.OBJ.user.data.MultiFx).concat(Dp.OBJ.user.data.ScaleBlurFX);

  Dp.OBJ.setFxs(FXs);
  Dp.OBJ.setRts(RTFxs);

  main();
  Dp.OBJ.setState("init");
  //
  // if(Dp.windowtype != "main"){
  //   Dp.remoteVideo = document.createElement( 'video' );//document.getElementById('remote_video');
  //   Dp.remoteVideo.autoplay = true;
  //   Dp.remoteVideo.style.display = 'block';
  //   Dp.remoteVideo.style.width = '100%';
  //   Dp.remoteVideo.style.height = 'auto';
  //
  //   Dp.localStream = document.createElement("canvas").captureStream();
  //   document.getElementById( 'canvas-frame' ).appendChild( Dp.remoteVideo );
  //
  //   Dp.channel.postMessage({massage:"initPJ",fromWindowtype:Dp.windowtype});
  //   // console.log(D)
  // }else if(Dp.mainLoaded){
  //   window.location.reload();
  //   return;
  //
  //   if(Dp.Movs_bak){
  //     if(Dp.rendererDp.OBJ) document.getElementById( 'canvas-frame' ).append( Dp.rendererObj.domElement );
  //
  //     Dp.OBJ.setMovs(Dp.Movs_bak);
  //     Dp.setMenu(Dp.menu);
  //     Dp.OBJ.setState("loaded");
  //
  //   }else Dp.OBJ.setState("init");
  //
  // }else{
  //   main();
  //   Dp.OBJ.setState("init");
  // }

}

function initVals(){
  Dp.setVals = (vl)=>{
    function setVal(obj,val,key2,value2){
      if(val) val[key2] = value2;
      if(obj){
        if(typeof obj[key2] === 'function'){
          if(key2 != "video1" && key2 != "video2" && typeof value2 !== "undefined" )obj[key2](value2);
          // obj[key2](value2);
        }
        else obj[key2] = value2
      }
    }

    for (let [key, value] of Object.entries(vl)) {
      if(typeof value == "object" && !Array.isArray(value)){
        for (let [key2, value2] of Object.entries(value)) {
            // console.log(key,key2);
            setVal(snap.obj[key],snap.val[key],key2,value2)
        }
      }else{
        setVal(snap.obj,snap.val,key,value)
        // snap.val[key] = value;
      }
    }
    // Dp.paramFunc();
  }

  // var Movs = Object.values(videos);
  Dp.Movs = [...Object.values(videos),...Object.values(images)];
  Dp.progress = {pre:[],current:[]};
  Dp.makeThumbs = [];

  Dp.initPj();
  document.getElementById( 'canvas-frame' ).appendChild(Dp.renderer);

  Dp.OBJ.setState("thumbCreating");
  // Dp.Movs_bak = Movs;
  Dp.OBJ.setMovs(Dp.Movs);
  // Dp.OBJ.setState("loaded");

  Dp.setMenu(Dp.menu);
  Dp.OBJ.setBanks(snap.val.banks);

  // Dp.makeThumbsLength = Dp.makeThumbs.length;
  // mov.func(Dp.makeThumbs.shift());

  // initBuild(snap.init.val);
  // if(snap.val.needsUpdate)initBuild(snap.init.val);
}

function wrapInitVals(src,dst){
  src.thumbs["webCam"] = "/img/camera.png";
  src.thumbs["remoteCamera"] = "/img/camera.png";
  src.thumbs["displayCapture"] = "/img/webview.png";
  src.thumbs["RenderTexture"] = "/img/screencaputure.png";
  dst.val = src;
}

var openSample = async function(path){
  // try {
    if(window.isElectron){
      openPj("/sampleDirectoryPicker");

    }else{
      Dp.OBJ.setState("loading");//Utl.CookiesSet(list,'SampleconfJson') Utl.CookiesGet('urls')
      var res = Utl.CookiesGet('SampleconfJson');
      if(res){
        wrapInitVals(res,snap.init);
        // snap.init.val = res;
        Object.keys(snap.init.val.thumbs).forEach( function( key ) {
          var name = key.split("/");
          if(name[1] == "Resources") {
            videos[key] = key;
          }
        })

      }else{
         try{
           res = await Utl.Axios.get(path+"config.designpad");
         } catch(err){
             console.log('err:', err);
         }

        if(res.data) wrapInitVals(res.data,snap.init);
        // if(res.data){

        // snap.init.val = res.data;
        Object.keys(snap.init.val.thumbs).forEach( function( key ) {
          var name = key.split("://");
          if(name[0] == "file") {
            videos[key] = path+name[1];
            snap.init.val.thumbs[videos[key]] = snap.init.val.thumbs[key];
            delete  snap.init.val.thumbs[key];

            //初期化するMovの名前を変更
            Object.values(snap.init.val.initVals.currentMov).map(
              (val)=>{
                if(val.mov == key) val.mov = videos[key];
              }
            )
            // console.log(snap.init.val.initVals.currentMov);
          }
        })
        // }
      }
      //
      // if(!res.data)res = await Utl.Axios.get("/Resources/movies/config.json");
      // console.log(res);
      //
      // if(res.data){
      //   snap.init.val = res.data;
      //   // snap.val.needsUpdate = true;
      //   // confJson = res.data;
      //   Object.keys(snap.init.val.thumbs).forEach( function( key ) {
      //     var name = key.split("://");
      //     if(name[0] == "file") {
      //       videos[key] = "/Resources/movies/"+name[1];
      //       snap.init.val.thumbs[videos[key]] = snap.init.val.thumbs[key];
      //     }
      //
      //     name = key.split("/");
      //     if(name[1] == "Resources") {
      //       videos[key] = key;
      //     }
      //   });
      // }
      // console.log(confJson,videos);
      // initBuild(confJson.data)

      initVals();

    // } catch (error) {
    //   console.log(error);
    // }
  }
}

var openPj = async function(path){
  // Dp.windowtype = "main";
  // console.log("openPj")

  // alert("aaa");
  // console.log("test")
  // if(window.api){
    // const res = await Utl.AxiosWrap.get("/openFolder");
    // console.log(res.data);
    // if(res.data)
    //openSample("/openFolder/");

  // }else
  if(await openFolder(path)){
    // {RTFxs;,ColorFX,FlashInkFX,MultiFx,ScaleBlurFX} = OBJ.user.data;
    // RTFxs = OBJ.user.data.RTFxs;
    // FXs = OBJ.user.data.ColorFX.concat(OBJ.user.data.FlashInkFX).concat(OBJ.user.data.MultiFx).concat(OBJ.user.data.ScaleBlurFX);

    initVals();
    Dp.OBJ.update(Math.random());
    snap.obj.initVals.currentFx(snap.val.initVals.currentFx);

    // Dp.paramFunc = ()=>{
      Dp.params = {};
      const f = (obj)=>{
        const d = obj.userData;
        if(d.params){
          d.params.obj = obj;
          if(!Dp.params[d.params.key])Dp.params[d.params.key] = [];
          Dp.params[d.params.key].push(d.params);
        }
      }

      Dp.scene.traverse(f)
      snap.init.sceneObj.traverse(f)

      Dp.OBJ.setParams(Object.keys(Dp.params));
    // }
    // Dp.paramFunc();
  }
}

// function initBuild(json){
//   for (let [key, value] of Object.entries(json)) {
//       for (let [key2, value2] of Object.entries(value)) {
//           // console.log(key,key2);
//           if(snap.val[key]) snap.val[key][key2] = value2;
//           if(snap.obj[key]){
//             // console.log(key,key2,value2,snap.obj[key]);
//             if(typeof snap.obj[key][key2] === 'function') snap.obj[key][key2](value2);
//             else snap.obj[key][key2] = value2
//           }
//       }
//   }
// }


var fx = {},banks = {},mov = {},tweens = {};
var saveFolders = [];
var handles;

async function openFolder(path) {
   try {
     if(window.isElectron){
       // if(window.api){
       const res = await Utl.Axios.get(path);
       handles = res.data;

     }else{
       handle = await window.showDirectoryPicker();//chooseFileSystemEntries({ type: 'open-directory' });
       handles = handle.values();
     }
     Dp.OBJ.setState("loading");

     // entries = await handle.getEntries();
     // for await (const entry of entries) {

     for await (const entry of handles) {
         saveFolders.push(entry);
           //fileHandles.push(entry);
         var a = entry.name;
         var nm;
         if(window.isElectron) nm = "/openFolder/"+a;
         else nm = 'file://'+a;
         // }else{
         //   text = await entry.getFile().then(file => file.text());
         //   text = JSON.parse(text);
         // }
         console.log(a);

         if(a.match(/\.(designpad)$/i)){//a.slice( -10 ) == ".designpad"){//a == "config.json"){
           //confJson = entry;
           confJsonhandle = entry;
           var text;
           if(window.isElectron){
             text = await Utl.Axios.get(nm);
             text = text.data;
           }else{
             text = await entry.getFile().then(file => file.text());
           }

           if(typeof text != "object") text = JSON.parse(text);
           // snap.init.val = JSON.parse(res);
           wrapInitVals(text,snap.init);

           // Dp.overWrightFile();

           // initBuild(snap.init.val);
           // snap.val.needsUpdate = true;
           console.log(snap.init.val)

         }else if(a == "scene.json"){
           var text;

           if(window.isElectron){
             text = await Utl.Axios.get(nm);
             text = text.data;
           }else{
             text = await entry.getFile().then(file => file.text());
           }

           if(typeof text != "object") text = JSON.parse(text);
           snap.init.scene = text;


         }else if(a.match(/\.(mp4|mov|webm|png|jpg|jpeg)$/i)){//} || a.slice( -4 ) == ".mov" || a.slice( -5 ) == ".webm" || a.slice( -4 ) == ".png"){
           if (a.length > 20) { //もし、バイト数が144バイト以上だったら
             a = a.slice(0, 10)+"..."+a.slice( -10 ); //最後に3点リーダー
           }

           if(a.match(/\.(mp4|mov|webm)$/i)){//}    Utl.isExtend("mp4") || Utl.isExtend("mov") || Utl.isExtend(".webm")){
             if(!window.isElectron) videosFile[nm] = true;//await entry.getFile();
             videos[nameCHeck(videos,a,1,a)] = nm//entry.name;
             //console.log(entry.name);
           // }
           }else{
             // 関数化
              async function loadImage(src) {
                return new Promise((resolve, reject) => {
                  const img = new Image();
                  img.onload = () => resolve(img);
                  img.onerror = (e) => reject(e);
                  img.src = src;
                });
              }

             Dp.imagesFile[nm] = await loadImage(nm).catch(e => {
                console.log('onload error', e);
              });;//await entry.getFile();

             images[nameCHeck(images,a,1,a)] = nm//entry.name;
           }

           function nameCHeck(videos,a,cnt,org){
             cnt++;
             if(videos[a]) return nameCHeck(org+"["+cnt+"]",cnt,org);
             else return a;
           }
         }
       }


       //Load scene
       if(!snap.init.scene){
         text = await Utl.Axios.get("Resources/Customscene/scene.json");
         text = text.data;

         if(typeof text != "object") text = JSON.parse(text);
         snap.init.scene = text;
         snap.init.banks = BANKS_INIT;
       }

       const promise = new Promise(resolve => {
         const loader = new THREE.ObjectLoader();
         loader.parse(text, (obj) => {
           snap.init.sceneObj = obj;
           Dp.animations = {};
           // Dp.mixers = {};
           resolve();
         })
       });

       await promise; // 1 秒待機

       console.log(snap.init.scene);

       snap.init.scene.object.children.forEach((cld,pIndex) => {
        if(cld.type == "Group" && cld.name != "ignor"){
          cld.children.forEach((key,index) => {
             const obj_name = "imported_"+cld.name+"_"+key.name+"_"+index;
             if(key.type == "PerspectiveCamera"){
               if(key.userData.distance){
                 //パラメータ取得
                 snap.init.val[key.name] = key.userData;
               }

             }else if(key.type == "Mesh"){
               const geo = text.geometries.find((v) => v.uuid === key.geometry);
               const b = {
                 ...geo,
                 ...key.userData.build
               };
               snap.init.build[obj_name] = b;
               b.layer = eval(b.layer);
               b.Geometry = b.type;
               b.renderOrder = key.renderOrder;
               b.group_name = cld.name;

               if(!b.distance )b.distance = dfaultDistance;

               const m4 = new THREE.Matrix4();
               // const v3 = new THREE.Vector3();

               const n = key.matrix;
               m4.set(
                 n[0],
                 n[1],
                 n[2],
                 n[3],
                 n[4],
                 n[5],
                 n[6],
                 n[7],
                 n[8],
                 n[9],
                 n[10],
                 n[11],
                 n[12],
                 n[13],
                 n[14],
                 n[15]
               );

               // // const m = ["width",0,0,0,0,"height",0,0,0,0,"depth",0,"PosX","PosY","PosZ",1]
               // // const v3 = new THREE.Vector3();
               //.setRotationFromMatrix(m4);
               // v3.setFromMatrixScale(m4);

               const o3d = new THREE.Object3D();
               o3d.applyMatrix4(m4)

               const t = new THREE.Vector3();
               const r = new THREE.Quaternion();
               const s = new THREE.Vector3();
               m4.decompose(t, r, s);
               r.invert();

               const m4q = new THREE.Matrix4();
               m4q.makeRotationFromQuaternion(r);

               m4.multiply(m4q);
               m4.decompose(t, r, s);

               snap.init.val[obj_name] = {
                 ...geo,
                 "width": s.x,
                 "height": s.y,
                 "depth": s.z,
                 "PosX": n[12],
                 "PosY": n[13],
                 "PosZ": n[14],
                 "RotX": -o3d.rotation.x,
                 "RotY": -o3d.rotation.y,
                 "RotZ": -o3d.rotation.z,
                 // "matrix": key.matrix,
                 ...key.userData.val,
               };

               // snap.init.val[obj_name].width = v3.x;
               // snap.init.val[obj_name].height = v3.y;
               // snap.init.val[obj_name].depth = v3.z;

               // snap.init.val[obj_name] = v;

               // {
                   // "layer":FX_SCENE,
                   // "renderOrder":10+index,
                   // "Geometry": "Plane",
                 //   "width": [0, 1280],
                 //   "height": [0, 720]
                 // }
               //
               // snap.init.val["mesh_"+key[1]+key[2]] = {
               //    "ch": key[1]+key[2],
               //    "width": "width",
               //    "height": "height",
               //    "PosX": 0,
               //    "PosY": 0,
               //    "PosZ": 0,
               //    "RotX": 0,
               //    "RotY": 1.5,
               //  }
               const uuid = cld.children[index].uuid
               snap.init.build[obj_name] = {
                 ...snap.init.build[obj_name],
                   "group_name":cld.name,
                   "group_ref": cld.uuid,
                   "ref": uuid,
               };

             }else{
               const uuid = cld.children[index].uuid
               snap.init.build[obj_name] = {
                 "group_name":cld.name,
                 "group_ref": cld.uuid,
                 "ref": uuid,
               };

               // if(key.type == "Mesh")
               // {
               //   const b = key.userData.build
               //
               //   b.layer = eval(b.layer);
               //   b.Geometry = b.type;
               //   b.renderOrder = key.renderOrder;
               //   b.group_name = cld.name;
               //
               //   if(!b.distance )b.distance = dfaultDistance;
               //
               //   snap.init.build[obj_name] = {
               //     ...snap.init.build[obj_name],
               //     ...b,
               //   }
               //
               // }
             }
          });
        }
      });

      console.log(snap.init.scene)
      console.log(snap.init)

      videos = objectSort(videos);
      images = objectSort(images);
       return true;

   } catch (ex) {
       console.error("ファイル取得に失敗しました", ex);
       return false;
   }
}

function objectSort(object) {
    //戻り値用新オブジェクト生成
    var sorted = {};
    //キーだけ格納し，ソートするための配列生成
    var array = [];
    //for in文を使用してオブジェクトのキーだけ配列に格納
    for (var key in object) {
        //指定された名前のプロパティがオブジェクトにあるかどうかチェック
        if (object.hasOwnProperty(key)) {
            //if条件がtrueならば，配列の最後にキーを追加する
            array.push(key);
        }
    }
    //配列のソート
    array.sort();
    //配列の逆ソート
    //array.reverse();

    //キーが入った配列の長さ分だけfor文を実行
    for (var i = 0; i < array.length; i++) {
        /*戻り値用のオブジェクトに
        新オブジェクト[配列内のキー] ＝ 引数のオブジェクト[配列内のキー]を入れる．
        配列はソート済みなので，ソートされたオブジェクトが出来上がる*/
        sorted[array[i]] = object[array[i]];
    }
    //戻り値にソート済みのオブジェクトを指定
    return sorted;
}

async function getmp4(name) {
 try {
   //entries = await handle.getEntries();
     // for await (const entry of entries) {
     //   if('file://'+entry.name == name) var a = await entry.getFile();
     //   //console.log(entry.name);
     // }
     var a;
     await Promise.all(saveFolders.map(async entry => {
       if('file://'+entry.name == name) {
         a = await entry.getFile();
       }
     }))

     // saveFolders.forEach( function( entry ) {
     //   if('file://'+entry.name == name) var a = await entry.getFile();
     // });

     return a;

 } catch (ex) {
     console.error("ファイル取得に失敗しました", ex);
     return false;
 }
}

Dp.overWrightFile = async () => {
  // // create a new handle
  // const newHandle = await window.showSaveFilePicker();

  // create a FileSystemWritableFileStream to write to
  // if(!confJsonhandle) confJsonhandle = await window.showSaveFilePicker({
  //   _preferPolyfill: false,
  //   suggestedName: 'config.json',
  //     types: [
  //       { accept: { "text/json": [ ".json" ] } },
  //     ],
  //     excludeAcceptAllOption: false // default
  // });
  if(handle){
    if(!confJsonhandle){
      const opts = {
        types: [{
          description: 'DesignPad config file',
          accept: {'application/json': ['.designpad']},
        }],
      };
      confJsonhandle = await window.showSaveFilePicker(opts);
      Dp.OBJ.setState("loading");
    }

    if(confJsonhandle){
      const writableStream = await confJsonhandle.createWritable();
      const blob = Dp.buildBlob();

      // write our file
      await writableStream.write(blob);

      // close the file and write the contents to disk.
      await writableStream.close();
    }

  }else if(window.isElectron){
    // const blob = Dp.buildBlob();
    // const blob = new Blob(['本日は晴天なり'], { type: 'text/plain' })
    //
    // const data = new FormData();
    // data.append('data', blob);
    // console.log(data);
    //
    // Utl.AxiosWrap.post('upload', data, {
    //     headers: {
    //       'Content-Type': 'multipart/form-data'
    //     }
    // })

    var params = new URLSearchParams();
    params.append('data', encodeURIComponent(JSON.stringify(snap.val, null, '  ')));
    Utl.AxiosWrap.post('/openFolder', params);

    //
    // Utl.AxiosWrap.post('/test', {
    //   data: 'test'
    // })
    // .then(function (response) {
    //   console.log(response);
    // })
    // .catch(function (error) {
    //   console.log(error);
    // });

  }else{
    Utl.CookiesSet(snap.val,'SampleconfJson')
    console.log(Utl.CookiesGet("SampleconfJson"))
  }
}

var trialTime;
// var timer = setInterval(trial, 1000);
//
// var trial = function(){
//   if(window.payed){
//     clearInterval(timer);
//
//   }else if(trialTime){
//     $("#msg").html("無料トライアルは、残り"+Math.ceil((trialTime - Date.now())/1000)+"秒です。");
//     if(trialTime < Date.now()){
//       page("project_timeout");
//       clearInterval(timer);
//     }
//   }
// };
//
//
//

const TimeBase = {fx:[],tweens:{},"save":new Date().getTime(),lon:0,lat:0,latMotion:'base',lonMotion:'base',latMotionSize:0,lonMotionSize:0};

function main() {
  if(!trialTime)trialTime = Date.now() + 1000 * 60 *10;
  //Animation
   snap.obj = {
     TimeBase:TimeBase
   };
   snap.val = {
     oprnUrl:[""],
     addBanks:{
        "TimeBase/bpm":false,
        "bloomExposure":false,
        "bloomRadius":false,
        "bloomStrength":false,
        "bloomThreshold":false,
        "material 5/ChromaKey":false,
        "material 5/ChromaKey_hue":false,
        "material 5/ChromaKey_saturation":false,
        "material 5/ChromaKey_brightness":false,
        "material 5/ChromaKey_contrast":false,
        // "cuts/current":false,
        "cuts/camera":false,
        "cuts/mode":false,
        "cuts/type":false,
        "groups":true,
        "initVals/currentMixer":false,
        "initVals/currentParam":false,
        "initVals/currentAnimations":false,
        "initVals/currentWeb":false,
        "initVals/currentFx":false,
        "initVals/currentMov/chA":false,
        "initVals/currentMov/chB":false,
        "initVals/currentMov/chC":false,
        "initVals/currentMov/chDJ":false,
      },
     initVals:{
       currentAnimations:{},
       currentMixer:{
         " 1": 1,
         " 3": 1,
         " 5": 1,
         " 2": 1
       },
       currentParam:{},
       currentMov:{},
       currentFx:21,
       currentWeb:{},
     },
     TimeBase:{"bpm":140},
     thumbs:{}
   };

   if(!snap.val.banks) snap.val.banks = BANKS_INIT;//snap.init.banks;

   wrapInitVals(snap.val,snap);

   snap.obj.initVals = {
     currentMov:(movs,force)=>{
       Object.values(movs).map((val)=>{
         if(!val.displayCaptureName || force) Dp.channel.postMessage({massage:"setMov",param:val})
       })
     },
     currentAnimationsClip:{},
     currentAnimations:(clips)=>{
        Object.keys(clips).map((key)=>{
          if(snap.obj.initVals.currentAnimationsClip[key])snap.obj.initVals.currentAnimationsClip[key](clips[key]);
        })
      },
      currentParam:(lyr)=>{
        Object.keys(lyr).map((key)=>{
          if(!Dp["getElementById"+key])return;
          if(Dp["getElementById"+key].value != lyr[key]) Dp["getElementById"+key].value = lyr[key];

          // console.log(key+" => "+lyr[key]);
          // console.log(Dp.params[key]);

          Dp.params[key].map((val)=>{
            Object.keys(val.changes).map((prop)=>{
              if(typeof val.obj[prop] != "undefined"){
                var v = lyr[key];
                var v2 = val.changes[prop].range;
                if(v2){
                  v = v2[0] + (v2[1]-v2[0]) * v;
                }
                if(val.changes[prop].sub){
                  var t = typeof val.obj[prop][val.changes[prop].sub];
                  if(t != "undefined")val.obj[prop][val.changes[prop].sub] = v;
                  // val.obj[prop].set(0,v,0);
                } else val.obj[prop] = v;

                console.log(val.obj[prop]);
                console.log(val.obj);
                console.log(prop);
              }
            });
          })
        })
      },
      currentMixer:(lyr)=>{
        Object.keys(lyr).map((key)=>{
          Dp.channel.postMessage({massage:"setFxDirect",param:{cat:"material",lyr:key,keys:{"fader":lyr[key]}}});
        })
      },
     currentFx:(key)=>{
       Dp.channel.postMessage({massage:"setFx",param:FXs[key],opt:{key:key}});
       // Dp.paramFunc();
     },
     currentWeb:async (vals)=>{
       async function cntlWeb(vals,visible){
         await Promise.all(Object.values(vals).map(async (val)=>{
           const index = snap.val.oprnUrl.indexOf(val.url);
           if(index != -1) {
             val.id =  "Web"+(snap.val.oprnUrl.length - index);
             val.prop.id = val.id;

             val.prop.visible = "show";
             await Utl.ctrlWindow(val);
           }
         }));
       }


       await Utl.desktopCapturer();
       Utl.LastDesktopCapturer.map((v)=>{
         const index = snap.val.oprnUrl.indexOf(v.name);
         if(index != -1) {
           const id = "Web"+(snap.val.oprnUrl.length - index);
           const prop = {
              id: id,
              prop: {id: id, visible: "close"},
              url: v.name
           }
           Utl.ctrlWindow(prop);
         }
       })

       if(snap.val.oprnUrl) {
         // await Utl.Axios.get("/setWindowUrl/");
         await cntlWeb(vals);
         Utl.ctrlWindow({visible:"hide"})
       }

         // snap.obj.initVals.currentMov(snap.val.initVals.currentMov);

         Object.keys(snap.val.initVals.currentMov).map((key)=>{
           if(snap.val.initVals.currentMov[key].displayCaptureName){
             const mov = {}
             mov[key] = snap.val.initVals.currentMov[key];
             snap.obj.initVals.currentMov(mov,true);
           }
         })
       // }
     }
   }

  //snap = {obj:{TimeBase:TimeBase},val:{TimeBase:{}}};

  // gui = new dat.GUI();
  // dat.GUI.toggleHide();
  // 動画に合わせてテクスチャを更新
  // setInterval( function () {
  //     for (let [key, value] of Object.entries(guis)) {
  //         for (var ii in value.__controllers) {
  //             value.__controllers[ii].updateDisplay();
  //         }
  //     }
  // }, 100 );


   // var guis = {};
   // guis.TimeBase = gui.addFolder("TimeBase");
   // guis.mixer = gui.addFolder("Mixer");
   // guis.conf = gui.addFolder("conf");

   var ease = ['base','ease','pinpon','pinponEase','pinponDulay','pinponDulayEase'];
   ease.forEach( function( item ) {
       TimeBase[item] = 0;
       // guis.TimeBase.add(TimeBase, item, 0, 1);
   });

   snap.obj.TimeBase.bpm = (val)=>{
     Dp.bpm(val);
   }

   Dp.bpm = (val)=>{
     snap.val.TimeBase.bpm = val
     Dp.setBpm(val);
     Dp.channel.postMessage({massage:"getBpm",val:val});
   };

   // guis.TimeBase.add(TimeBase, 'bpm', 30, 200).onChange(Dp.bpm);
   // OBJ.Add({
   //   tab:"Setting",
   //   group:"Camera",
   //   type:"slider",
   //   obj:TimeBase,
   //   name:'bpm',
   //   key:'bpm',
   //   step:1,
   //   min:30,
   //   max:200,
   //   func:Dp.bpm,
   // });


   // guis.TimeBase.add(TimeBase, 'latMotion', ease).onChange((val)=>snap.val.TimeBase.latMotion = val);
   // guis.TimeBase.add(TimeBase, 'latMotionSize', 0, 90).onChange((val)=>snap.val.TimeBase.latMotionSize = val);
   // guis.TimeBase.add(TimeBase, 'lonMotion', ease).onChange((val)=>snap.val.TimeBase.lonMotion = val);
   // guis.TimeBase.add(TimeBase, 'lonMotionSize', 0, 90).onChange((val)=>snap.val.TimeBase.lonMotionSize = val);

   snap.val.cuts = {"mode":"10","type":"base","length":11,"current":10,"camera":null,"layout":"2 column","dispWidth":Utl.CONF.defaultWidth,"dispHeight":Utl.CONF.defaultHeight};
   var motions = ["stop","loop","random"];
   for (let i = 0; i < snap.val.cuts.length; i++) {
     motions.push(i);
     // guis["cut"+i] = guis.TimeBase.addFolder("cut"+i);
     addCut("start");
     addCut("end")

     function addCut(name){
       var n = "cut"+i+name;
       // guis[n] = guis["cut"+i].addFolder(name);
       snap.obj[n] = {};
       snap.val[n] = {};
       var trans = {"PosX":[-300,300],"PosY":[-300,300],"PosZ":[-300,300],"lat":[-85,85],"lon":[-180,180],"distance":[-300,300],"RotZ":[-3,3]};
       for (let [key, value] of Object.entries(trans)) {
           snap.val[n][key] = 0;
           //snap.obj[n][key] = () => updateTrans(param);
           // guis[n].add(snap.val[n],key,value[0],value[1])//.onChange(snap.obj[name][key]);
       }
     }
    }

    snap.obj.cuts = {
      dispWidth:(val)=>{
        snap.val.cuts.dispWidth = val;
        onWindowResize(null);
      },

      dispHeight : (val)=>{
        snap.val.cuts.dispHeight = val;
        onWindowResize(null);
      },

            // mode:val => {
      //   if(val != "stop" && val != "loop" && val != "random") snap.val.cuts.current = Number(val);
      // },
      type:val => {
        if(Array.isArray(val))snap.obj.cameraChange(val[0]);
        else snap.obj.cameraChange(snap.val.cuts.camera);
      },
      // mode:val => {
      //   if(val != "stop" && val != "loop" && val != "random") snap.val.cuts.current = Number(val);
      // },
      layout:(v)=>{
        snap.val.cuts.layout = v;
        Dp.OBJ.update(Math.random());
        // if(v=="1 column") Dp.channel.postMessage({massage:"1 column"});
        // if(v=="2 column") Dp.channel.postMessage({massage:"closeSub"});
      },
    };
    //
    // snap.obj.cuts = (val)=>{
    //   snap.val.cuts = val;
    //   if(val.mode != "stop" && val.mode != "loop" && val.mode != "random") snap.val.cuts.current = Number(val.mode);
    //
    //   if(val.mode == "2d"){
    //     snap.obj.cameraChange(1);
    //
    //   }if(val.current == "imported"){
    //     snap.obj.cameraChange(val.type);
    //
    //   }else if(val.mode != "2d"){
    //     snap.obj.cameraChange(0);
    //   }
    // }
    // guis.TimeBase.add(snap.val.cuts,"mode",motions).onChange(snap.Dp.OBJ.cuts.mode);

    Dp.OBJ.Add({
      tab:"Setting",
      group:"Camera",
      type:"select",
      obj:snap.val.cuts,
      name:"mode",
      key:"mode",
      options:motions,
      func:snap.obj.cuts.mode
    });

 // 変数の初期化
   // var w = 400;
   // var h = 640;


   // OBJ.Add({
   //   tab:"Setting",
   //   group:"Screen",
   //   type:'text',
   //   obj:TimeBase,
   //   name:'dispWidth',
   //   key:'dispWidth',
   //   step:1,
   //   min:1,
   //   max:2000,
   //   func:snap.obj.snap.val.cuts.dispWidth_f
   // });
   //
   // OBJ.Add({
   //   tab:"Setting",
   //   group:"Screen",
   //   type:'text',
   //   obj:TimeBase,
   //   name:'dispHeight',
   //   key:'dispHeight',
   //   step:1,
   //   min:1,
   //   max:1000,
   //   func:snap.obj.snap.val.cuts.dispHeight_f
   // });
   //
   // guis.TimeBase.add(TimeBase, 'dispWidth', 1, 2000).onChange(snap.obj.snap.val.cuts.dispWidth_f);
   // guis.TimeBase.add(TimeBase, 'dispHeight', 1, 1000).onChange(snap.obj.snap.val.cuts.dispHeight_f);


var composer,composer_layer,afterimagePass,mixer;

var bloomLayer = new THREE.Layers();
bloomLayer.set( BLOOM_SCENE );

var bloomIgnorLayer = new THREE.Layers();
bloomIgnorLayer.set( BLOOM_IGNOR );

var fxLayer = new THREE.Layers();
fxLayer.set( FX_SCENE );

// var params = {
//  exposure: 1,
//  bloomStrength: 1.5,
//  bloomThreshold: 0,
//  bloomRadius: 0
// };

 var updateTexture = [];
 var cameras,camera,camera2, scene, renderer,renderer2, container,videosOpsion,renderTarget,renderTarget_layer,renderTarget_layer_swap,current_rt,cameraHeight,cameraWidth,clock;
 var renderSceneCamera1,renderSceneCamera2,bloomPass,finalPass,finalComposer;
 var fov = 100,
 isUserInteracting = false,
 onMouseDownMouseX = 0, onMouseDownMouseY = 0,

 lon = 0, onMouseDownLon = 0,
 lat = 0, onMouseDownLat = 0,
 phi = 0, theta = 0;

 videosOpsion = [];

 init();
 animate();

 function init() {
   clock = new THREE.Clock();

   // カメラを生成    ENTIRE_SCENE = 0, BLOOM_SCENE = 1, BLOOM_IGNOR = 2, FX_SCENE = 3, DUMMY_SCENE

   camera = new THREE.PerspectiveCamera( fov, Utl.CONF.defaultWidth / Utl.CONF.defaultHeight, 1, 2000 );
   camera.layers.disableAll()
   camera.layers.enable(ENTIRE_SCENE);
   camera.layers.enable(BLOOM_SCENE);
   camera.layers.enable(BLOOM_IGNOR);
   // camera.layers.enable(FX_SCENE);
   Dp.camera = camera;

   camera2 = new THREE.PerspectiveCamera( fov, snap.val.cuts.dispWidth / snap.val.cuts.dispHeight, 1, 2000 );
   camera2.layers.disableAll()
   // camera2.layers.enable(ENTIRE_SCENE);
   // camera2.layers.enable(BLOOM_SCENE);
   // camera2.layers.enable(BLOOM_IGNOR);
   camera2.layers.enable(FX_SCENE);
   camera2.position.z = dfaultDistance;
   // cameras = [camera,camera2];

   snap.obj.cameraChange = (num)=>{
     if(typeof num == "number"){
       Dp.activeCamera = Dp.camera;
       snap.val.cuts.camera = num;

     }else{
       Dp.activeCamera = Dp.cameraObjs.find((v) => v.uuid === num);
       snap.val.cuts.camera = 0;

     }
     if(Dp.renderSceneCamera1){
       Dp.renderSceneCamera1.camera = Dp.activeCamera
     }
   }
   // snap.obj.cameraCheck = ()=>{
   //   if(snap.val.cuts.camera == camera)return 1;
   //   if(snap.val.cuts.camera == camera2)return 2;
   // }
   snap.obj.cameraChange(1);


   // シーンを生成
   scene = new THREE.Scene();
   Dp.scene = scene;

   var mem_canvas = document.createElement("canvas");
   mem_canvas.width = 1;
   mem_canvas.height = 1;
   var context = mem_canvas.getContext('2d');
   context.fillStyle = "rgb(0, 0, 0)";
   context.fillRect(0, 0, 1, 1);
   var BlackTexture = new THREE.Texture(mem_canvas);
   BlackTexture.needsUpdate = true;


   renderTarget = new THREE.WebGLRenderTarget(4, 2);
   // renderTarget_layer = new THREE.WebGLRenderTarget(snap.val.cuts.dispWidth , snap.val.cuts.dispHeight);
   // renderTarget_layer_swap = new THREE.WebGLRenderTarget(snap.val.cuts.dispWidth , snap.val.cuts.dispHeight);
   //current_rt = [renderTarget_layer_swap,renderTarget_layer]
   // updateTexture.push(renderTarget.texture);

   snap.obj.fx = (fx) => {
     // console.log(fx)
     var adjust = 1;
     if(typeof fx.adjust !== 'undefined') adjust = fx.adjust;

     var rt = fx.rt
     var cat = fx.cat
     var lyr = fx.lyr
     var keys = fx.keys
     var name = cat + lyr;
     var param = snap.val["mesh_"+name];
     var ink = {
       0: "",
       2: " Sub",//sub
       4: " Sub2",
       9: "",
       33: " Add",//Add
       34: " Scr",
       35: " Mul",//Muliti
       37: " Scr",
       39: " Mul2",
       99: " Key",
     }

     var ch = {
           "material1":["mat_"+name],
           "material2":["mat_"+name],
           "material3":["mat_"+name],
           "material4":["mat_"+name],
           "material5":["mat_"+name],
           // "material3":["none"],
           "caputersystem":["mat_"+name,"RenderTexture"],
           "caputer2d360":["mat_"+name,"RenderTexture"],
           "caputer3d360":["mat_"+name,"RenderTexture"],
           "caputer_breaksystem":["mat_"+name,"RenderTexture"],
           "caputer_subsystem":["mat_"+name,"RenderTexture"],
           "dummy,screengui":["mat_"+name,"color2ColorEffectC"],
           "color1ColorEffectA":["mat_"+name,"color1ColorEffectA"],
           "color2ColorEffectA":["mat_"+name,"color2ColorEffectA"],
           "color3ColorEffectA":["mat_"+name,"color3ColorEffectA"],
           "color1ColorEffectB":["mat_"+name,"color1ColorEffectB"],
           "color2ColorEffectB":["mat_"+name,"color2ColorEffectB"],
           "color3ColorEffectB":["mat_"+name,"color3ColorEffectB"],
           "color1ColorEffectC":["mat_"+name,"color1ColorEffectC"],
           "color2ColorEffectC":["mat_"+name,"color2ColorEffectC"],
           "color3ColorEffectC":["mat_"+name,"color3ColorEffectC"],
//            "colorLayerEffect"] = _Texs[9];
           "color1VibeBlurEffectB":["mat_"+name,"color1ColorEffectC"],
           "color2VibeBlurEffectB":["mat_"+name,"color2ColorEffectC"],
           "color3VibeBlurEffectB":["mat_"+name,"color3ColorEffectC"],
           "color1VibeBlurEffectA":["mat_"+name,"color1ColorEffectC"],
           "color2VibeBlurEffectA":["mat_"+name,"color2ColorEffectC"],
           "color3VibeBlurEffectA":["mat_"+name,"color3ColorEffectC"],
     };

     // console.log(name);



     if(typeof keys.locH !== 'undefined') cvt("locH",cameraWidth);//keys,"locH",cameraWidth,cat,lyr)
     if(typeof keys.locV !== 'undefined') cvt("locV",cameraHeight);//keys,"locV",cameraHeight,cat,lyr)
     if(typeof keys.rotation !== 'undefined') cvt("rotation",1);//keys,"rotation",1,cat,lyr)

     if(typeof keys.flipH !== 'undefined') cvt("flipH",1);//keys,"flipH",1,cat,lyr);
     if(typeof keys.flipV !== 'undefined') cvt("flipV",1);//keys,"flipV",1,cat,lyr);

     if(typeof keys.width !== 'undefined') cvt("width",cameraWidth * -(param.flipH*2-1));//keys,"width",cameraWidth * -(param.flipH*2-1),cat,lyr)
     if(typeof keys.height !== 'undefined') cvt("height",cameraHeight * -(param.flipV*2-1));//keys,"height",cameraHeight * -(param.flipV*2-1),cat,lyr)
     //
     // if(typeof keys.flipH !== 'undefined') param.flipH = cvt(keys,"flipH",1,cat,lyr);
     // if(typeof keys.flipV !== 'undefined') param.flipV = cvt(keys,"flipV",1,cat,lyr);

     if(typeof keys.ink !== 'undefined') param.ink = keys.ink;
     if(typeof keys.movieRate !== 'undefined' && fx.cat == "material") {
       cvt("movieRate",1);
       if(lyr == " 1") snap.obj.chA["video1"]("movieRate",param.movieRate)
       if(lyr == " 2") snap.obj.chC["video1"]("movieRate",param.movieRate)
     }
     if(typeof keys.currentTime !== 'undefined' && fx.cat == "material") {
       cvt("currentTime",1);
       if(lyr == " 1") snap.obj.chA["video1"]("currentTime",param.currentTime)
       if(lyr == " 2") snap.obj.chC["video1"]("currentTime",param.currentTime)
     }

     if(typeof keys.material !== 'undefined'){
       var chfx = ch[keys.material[0]+keys.material[1]];
       param.ch = chfx[0]+ink[param.ink];
       if(fx.cat != "material") snap.obj[name].texture(chfx[1]);
       // console.log(param.ch)
     }
     snap.obj["mesh_"+name].ch(param);//updateTrans(param)

     if(typeof keys.blend !== 'undefined') cvt("blend",1);//keys,"blend",1,cat,lyr);
     if(typeof keys.fader !== 'undefined') cvt("fader",1);//cvt(keys,"fader",1,cat,lyr);
     if(typeof keys.fader !== 'undefined' && Dp[name]){
       if(Dp[name].value != param.fader)Dp[name].value = param.fader;
       // Dp.channel.postMessage({massage:"setMixer",ch:name,val:param.fader})
     }
     if(typeof keys.blend !== 'undefined' || typeof keys.fader !== 'undefined'){
       var op = param.blend * param.fader;
       snap.val[name].opacity = op;
       snap.obj[name].opacity(op);
       // console.log(name+" "+op + " " + keys.ink);
     }

      function cvt(call,max){//types,call,max,cat,lyr){
        var type = keys[call];
        var label = {
          "movieRate":"movieRate",
          "currentTime":"currentTime",
          "locH":"PosX",
          "locV":"PosY",
          "rotation":"RotZ",
          "flipH":"flipH",
          "flipV":"flipV",
          "width":"width",
          "height":"height",
          "blend":"blend",
          "fader":"fader",
        }[call]

        if(typeof type === "object"){
          // console.log([types,call,max,cat,lyr,adjust])
          if(typeof type.adjust === "number") param[label] = type.adjust * max * adjust;
          else if(typeof type.ctrl === "number") {
            if(type.add) param[label] = (type.add + Math.abs(type.ctrl * adjust)) * max;
            else param[label] = defCtrl[cat+lyr+call] + type.ctrl * max * adjust;

            // console.log(cat+lyr+call,param[label]);
          }

          else if(type.instance == "asFFT"){
            //BPMコールに記録
            if(!TimeBase.fx[cat+lyr]) {
              TimeBase.fx[cat+lyr] = {cat:cat,lyr:lyr,keys:keys}//types}
            }

            if(type.sendlist.pram1.sence == "beatfade") var val = Math.round(TimeBase.base*8%1)//TimeBase.pinponEase;
            else var val = TimeBase.base*16%1//EasingFunctions.easeOutQuart(TimeBase.base*4%1)

            if(type.sendlist.pram1.base == "1") param[label] = val;
            else param[label] = 1-val;


          }
          else param[label] = type.adjust * max;

        }else{
          param[label] =  type * max;
        }
        if(rt == "down")defCtrl[cat+lyr+call] = param[label];

        //param[label] = 0;
      }
    }

    banks.func = (val) => {
      Dp.setVals(val);
      // Dp.paramFunc();
    }

   fx.func = (fx,opt) => {
     if(!fx)return;
     snap.val.initVals.currentFx = opt.key;
     if(opt.tweenInit){
       TimeBase.tweens.fx = {func:Dp.fx.func,param:fx,opt:opt}
       return;
     }

     if(typeof opt.type == 'undefined'){
       TimeBase.fx = {};
       var def = {"mix":defDat.mix,"material":defDat.material};
       var data = fx.data;

     }else if(opt.type == "down"){
       var def = {"effect":defDat.effect};
       var data = fx;

     }else{
       var def = fx;
       var data = fx;
     }

     for (let [cat, lyrs] of Object.entries(Utl.jsonCopy(def))) {
       var lyrs_fx = data[cat];
       if(!lyrs_fx) lyrs_fx = {};
       for (let [lyr, keys] of Object.entries(lyrs)) {
         if(lyrs_fx[lyr]){
           for (let [key, val] of Object.entries(lyrs_fx[lyr])) {
              keys[key] = val;
           }
         }
         snap.obj.fx({cat:cat,lyr:lyr,keys:keys,adjust:opt.adjust,rt:opt.type})
         }
       }
     }

    mov.func = async (mov) => {
      snap.val.initVals.currentMov[mov.ch] = mov;
      if(typeof mov.displayCapture == "string") {
        if(mov.displayCapture){
          if(Utl.LastDesktopCapturer.find((v) => v.id === mov.displayCapture)) Dp.displayCapture = mov.displayCapture;
          else if(mov.displayCaptureName && window.api){
            await Utl.desktopCapturer();
            const val = Utl.LastDesktopCapturer.find((v) => v.name === mov.displayCaptureName);
            if(val)Dp.displayCapture = val.id;
            else return;
          }
        }
      }

      if(typeof mov.opacity == "number") snap.obj[mov.ch]["opacity_"+mov.ch](mov.opacity);
      //afterimagePass.textureComp.texture

      if(typeof mov.mov == "string") {
        snap.obj[mov.ch]["video1"](mov.mov,mov.makeThumb);
        if(mov.mov == "RenderTexture")updateAllMat(mov.ch,afterimagePass.textureComp.texture);
        else updateAllMat(mov.ch,snap.obj[mov.ch+"video1texture"]);
      }
      console.log(mov);
    }



   // var materials = {};
   // var materialChType = {"chA":"A","chC":"A","chB":"B","chD":"B","chDJ":null};
   var materialCh = ["chA","chC","chB","chD","chDJ"]//Object.keys(materialChType);

   var materialBase = {
     // "mat_chAB":new ChromaKeyMaterial(THREE.NormalBlending,false,3),//chAB
     // "mat_chAB Add":new ChromaKeyMaterial(THREE.AdditiveBlending,false,3),//chAB
     // "mat_chCD":new ChromaKeyMaterial(THREE.NormalBlending,false,4),//chAB
     // "mat_chCD Add":new ChromaKeyMaterial(THREE.AdditiveBlending,false,4),//chAB
     // "chABCD":new ChromaKeyMaterial(THREE.NormalBlending,false,0),//chAB
     // "chABCD Add":new ChromaKeyMaterial(THREE.AdditiveBlending,false,0),//chAB
     // "chCD":new ChromaKeyMaterial(THREE.NormalBlending,false,1),//chCD
     // "chCD Add":new ChromaKeyMaterial(THREE.AdditiveBlending,false,1),//chCD
     // "chDJ":new ChromaKeyMaterial(THREE.NormalBlending,true,0),//chDJ
     // "chCD Add LED":new ChromaKeyMaterial(THREE.AdditiveBlending,false,2),//chCD
     "Black":new ChromaKeyMaterial(THREE.NormalBlending,false,-1),//chCD
   }


   var inks = [
     ["",THREE.NormalBlending],
     [" Add",THREE.AdditiveBlending],
     [" Scr",{
       blending:THREE.CustomBlending,
       blendEquation:THREE.MaxEquation,
       blendSrc:THREE.OneFactor,
       blendDst:THREE.OneFactor
     }],
     [" Sub",{
       blending:THREE.CustomBlending,
       blendEquation:THREE.SubtractEquation,
       blendSrc:THREE.OneFactor,
       blendDst:THREE.OneFactor
     }],
     [" Sub2",THREE.NormalBlending],
     [" Mul",{
       blending:THREE.CustomBlending,
       blendEquation:THREE.ReverseSubtractEquation,
       blendSrc:THREE.OneFactor,
       blendDst:THREE.OneFactor
     }],
     [" Mul2",{
       blending:THREE.CustomBlending,
       blendEquation:THREE.ReverseSubtractEquation,
       blendSrc:THREE.ZeroFactor,
       blendDst:THREE.SrcColorFactor
     }],
     [" Key",THREE.NormalBlending],
   ]

   function setuniforms(name,key,value){
     inks.forEach(val => {
       if(materialBase["mat_"+name+val[0]]) materialBase["mat_"+name+val[0]].uniforms[key].value = value;
     })
   }

   //https://threejs.org/examples/#webgl_materials_blending_custom

   chs.forEach(key => {
     materialCh.push(key[1]+key[2]);
     const k = m_dummy[key[0]];
     // if(key[0]=="material1") var skip = 3
     // else if(key[0]=="material2") var skip = 4
     // else if(key[0]=="material3") var skip = 43
     // else if(key[0]=="material4") var skip = 44
     // else if(key[0]=="material5") var skip = 45
     if(k) var skip = k[0]
     else var skip = 5;

     if(key[0].indexOf('flipH') !== -1) var flip = [0.5,0];
     if(key[0].indexOf('flipV') !== -1) var flip = [0,0.5];

     inks.forEach(val => {
       if(val[0]==" Scr" && skip==5) var s = 6;
       else var s = skip;
       const m = new ChromaKeyMaterial(val[1],(val[0]==" Key"),s,val[0]==" Sub2",flip);
       // m.uniforms.rendertexture.value = fterimagePass.textureComp.texture;//renderTarget.texture;
       if(k)m.side = k[1];
       // if(key[0]=="material3")m.side = THREE.BackSide;
       materialBase["mat_"+key[1]+key[2]+val[0]] = m
     })
     //
     // materialBase["mat_"+key[1]+key[2]] = new ChromaKeyMaterial(THREE.NormalBlending,false,skip)
     // materialBase["mat_"+key[1]+key[2]+" Add"] = new ChromaKeyMaterial(THREE.AdditiveBlending,false,skip)
     // materialBase["mat_"+key[1]+key[2]+" Sub"] = new ChromaKeyMaterial(THREE.NormalBlending,false,skip)//{blending:THREE.NormalBlending,blendEquation:THREE.AddEquation,blendSrc:THREE.SrcAlphaFactor,blendDst:THREE.OneMinusSrcAlphaFactor},false,skip)
     // materialBase["mat_"+key[1]+key[2]+" Mul"] = new ChromaKeyMaterial({blending:THREE.CustomBlending,blendEquation:THREE.SubtractEquation,blendSrc:THREE.OneFactor,blendDst:THREE.OneFactor},false,skip)
     // materialBase["mat_"+key[1]+key[2]+" Mul2"] = new ChromaKeyMaterial(THREE.MultiplyBlending,false,skip)
     // materialBase["mat_"+key[1]+key[2]].uniforms.rendertexture.value = renderTarget.texture;
     // materialBase["mat_"+key[1]+key[2]+" Add"].uniforms.rendertexture.value = renderTarget.texture;
     // materialBase["mat_"+key[1]+key[2]+" Sub"].uniforms.rendertexture.value = renderTarget.texture;
     // materialBase["mat_"+key[1]+key[2]+" Mul"].uniforms.rendertexture.value = renderTarget.texture;
     // materialBase["mat_"+key[1]+key[2]+" Mul2"].uniforms.rendertexture.value = renderTarget.texture;
    })

    Object.keys(materialBase).map((key) => {
      materialBase[key].name = key;
    })

   var materialOptions = Object.keys(materialBase);
   // var materialBase = Object.values(materialBase);

   materialCh.forEach( function( item ) {
     if(item == "chB") initMixer();
     addCH(item);
   });

   function addCH(name){
     var param = {};
     snap.obj[name] = {};
     snap.val[name] = param;

     // guis[name] = guis.mixer.addFolder(name);
     // guis[name+"conf"] = guis.conf.addFolder(name);

      function makeVideo(nameSrc){
        Dp.makeThumbs = [];

          const canvas = document.createElement('canvas')
          const context = canvas.getContext('2d')

         // video 要素を生成
         var video = document.createElement( 'video' );
         // document.body.appendChild(video);

         video.crossOrigin = 'anonymous';
         video.loop = true;
         video.muted = true;
         video.setAttribute( 'webkit-playsinline', 'webkit-playsinline' );
         video.setAttribute( 'playsinline', 'playsinline' );
         video.setAttribute( 'muted', 'muted' );

         function setTextureAspect(val){
           if(name == "chDJ") snap.val.imported_dj_booth_DJ_0.textureAspect = val;
         }

         video.onloadedmetadata = function () {
           setTextureAspect(video.videoWidth / video.videoHeight);
            //
        		// var width = element.videoWidth ;
        		// var height = element.videoHeight ;
            //
        }

         // video からテクスチャを生成
         var texture = new THREE.Texture( video );
         texture.generateMipmaps = false;
         texture.minFilter = THREE.NearestFilter;
         texture.maxFilter = THREE.NearestFilter;
         texture.format = THREE.RGBFormat;

         updateTexture.push(texture);
         //
         // // 動画に合わせてテクスチャを更新
         // setInterval( function () {
         //     if ( video.readyState >= video.HAVE_CURRENT_DATA ) {
         //         texture.needsUpdate = true;
         //     }
         // }, 1000 / 30 );


         // var param = {};
         snap.obj[name+nameSrc+"texture"] = texture;
         snap.obj[name+nameSrc] = video;
         snap.obj[name][nameSrc] =
          async (value,makeThumb) => {
            if(value == "currentTime"){
              if(video.src != "" && makeThumb >= 0) video.currentTime = video.duration * makeThumb;
              return;

            }else if(value == "movieRate"){
              if(video.src != "") video.playbackRate = makeThumb;
              return;

            }else if(video.srcObject){
               const tracks = video.srcObject.getTracks();
               tracks.forEach(track => {
                track.stop();
              });
              video.srcObject = null;
              setTextureAspect(Utl.CONF.defaultTextureWidth/Utl.CONF.defaultTextureHeight);
            }else{
              setTextureAspect(Utl.CONF.defaultTextureWidth/Utl.CONF.defaultTextureHeight);
            }

             // snap.obj[name].materialRef.forEach( function( mat ) {
             //   mat.map = texture;
             // });

            var CanMake;

              if(value == "remoteCamera"){
                if(Dp.remoteVideoUser) playVideo(video,Dp.remoteVideoUser._videoTrack._player.videoElement.srcObject.clone());
                // Dp.remoteVideoStream = new MediaStream();
                //
                // // stream.addEventListener('addtrack', (event) => {
                // //   playVideo(video,stream);
                // //   console.log(`New ${event.track.kind} track added`);
                // // });
                //
                // stream.addTrack(Dp.remoteVideoTrack);
                // playVideo(video,stream);

                  // if(!makeThumb) startVideo(video,value);
                  setThumb()

              }else if(value == "webCam" || value == "displayCapture"){
                  if(!makeThumb) startVideo(video,value);
                  setThumb()

              }else if(value == "black" || value == "RenderTexture"){
                 //video.src = null;
                 video.removeAttribute('src'); // empty source
                 //video.load();

                 setThumb()
                 //setuniforms(name,"videotexture_layer",afterimagePass.textureComp.texture);
                 // snap.obj[name].materialRef.forEach( function( mat ) {
                 //   mat.map = BlackTexture;
                 // });

             }else if(value==""){
               setThumb("/img/noimage.png")
               video.removeAttribute('src'); // empty source
               //video.load();

             }else if(videosFile[value]){
                if(makeThumb)CanMake = true;
                else{
                  var a = await getmp4(value)
                  video.src = URL.createObjectURL(a);
                  video.play();
                  setThumb()
                }

             }else if(Dp.imagesFile[value]){
               canvas.width = Dp.imagesFile[value].width
               canvas.height = Dp.imagesFile[value].height
               context.drawImage(Dp.imagesFile[value], 0, 0, canvas.width, canvas.height, 0, 0, canvas.width, canvas.height)

               playVideo(video,canvas.captureStream());
               setThumb()

             }else {
               if(makeThumb)CanMake = true;
               else{
                 setThumb()
                 video.src = value;
                 video.play();
               }
             }


             function setThumb(thumb){
               if(!thumb)thumb = value;
               const t = Dp[name+"thumb"];
               if(t){
                 if(snap.val.thumbs[thumb])t(snap.val.thumbs[thumb]);
                 else t(thumb)
               }
               // snap.val[name+"thumb"] = snap.val.thumbs[thumb];
               Dp.channel.postMessage({massage:"setMixer",ch:name+"thumb",val:snap.val.thumbs[thumb]})
             }

             // if(makeThumb) await makeThumbnail(makeThumb,value,CanMake)
             //
             // async function makeThumbnail(img,file,can){
             //    if(can){
             //      if(snap.init.val.thumbs[file]){
             //        snap.val.thumbs[file] = snap.init.val.thumbs[file];
             //        img.src = snap.val.thumbs[file];
             //        next();
             //
             //      }else{
             //       const canvas = document.createElement('canvas')
             //       const context = canvas.getContext('2d')
             //
             //       //  読み込みが完了したらcanvas サイズを設定
             //       const onloadeddata = () => {
             //         canvas.width = 40;//video.videoWidth
             //         canvas.height = 29;//video.videoHeight
             //         video.currentTime = Math.ceil(video.duration / 4)
             //       }
             //
             //       //  video.currentTime が変更されたらキャプチャ
             //       const onseeked = () => {
             //         Dp.change = true;
             //         context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight, 0, 0, canvas.width, canvas.height)
             //         snap.val.thumbs[file] = canvas.toDataURL('image/jpeg');
             //         img.src = snap.val.thumbs[file];
             //
             //         video.removeEventListener( 'loadeddata', onloadeddata, false );
             //         video.removeEventListener( 'seeked', onseeked, false );
             //
             //         next();
             //       }
             //
             //       video.addEventListener( 'loadeddata', onloadeddata, false );
             //       video.addEventListener( 'seeked', onseeked, false );
             //
             //       // 動画を読み込む
             //       if(videosFile[value]){
             //         var a = await getmp4(file)
             //         video.src = URL.createObjectURL(a);
             //
             //       }else {
             //         video.src = value;
             //       }
             //     }
             //
             //   }else next();
             //
             //
             //   function next(){
             //     if(Dp.makeThumbs.length > 0) {
             //       if(Dp.makeThumbsLength < Dp.makeThumbs.length)Dp.makeThumbsLength = Dp.makeThumbs.length;
             //
             //       // console.log((Dp.makeThumbsLength - Dp.makeThumbs.length))
             //       // console.log((Dp.makeThumbsLength - Dp.makeThumbs.length) / Dp.makeThumbsLength)
             //       var per = Math.floor((Dp.makeThumbsLength - Dp.makeThumbs.length) / Dp.makeThumbsLength * 100);
             //       // console.log(per)
             //       Dp.setProgress(per);
             //       mov.func(Dp.makeThumbs.shift());
             //
             //     }else if(Dp.change){
             //       // Dp.thumbCreating = false;
             //
             //       const blob = buildBlob();
             //       const url = URL.createObjectURL(blob);
             //       Dp.link = document.createElement('a');
             //       Dp.link.href =  url;
             //       Dp.link.download = 'config.json';
             //       Dp.change = false;
             //
             //       Dp.OBJ.setState("thumbCreated");
             //    }else{
             //      Dp.OBJ.setState("loaded");
             //    }
             //   }
             // }

             // getUserMediaでカメラ、マイクにアクセス
             async function startVideo(localVideo,value) {
                 try{
                     let localStream;
                     if(value == "webCam") localStream = await navigator.mediaDevices.getUserMedia({video: true, audio: false});
                     // if(value == "RenderTexture") localStream = Dp.rendererStream;
                     if(value == "displayCapture") {
                       if(window.api.desktopCapturer){
                        // await window.desktopCapturer.getSources({ types: ['window', 'screen'] }).then(async sources => {
                          // for (const source of sources) {
                          //   console.log(source.name);
                          //   if (source.name === 'Electron') {
                          // console.log(sources);
                          // const source = sources[2];
                              try {
                                const stream = await navigator.mediaDevices.getUserMedia({
                                  audio: false,
                                  video: {
                                    mandatory: {
                                      chromeMediaSource: 'desktop',
                                      chromeMediaSourceId: Dp.displayCapture,
                                    }
                                  }
                                })
                                localStream = stream;
                                // handleStream(stream)
                              } catch (e) {
                                handleError(e)
                              }
                              // return
                            // }
                          // }
                        // })

                        // function handleStream (stream) {
                        //   //const video = document.querySelector('video')
                        //   video.srcObject = stream
                        //   video.onloadedmetadata = (e) => video.play()
                        // }

                        function handleError (e) {
                          console.log(e)
                        }

                     }else{localStream = await navigator.mediaDevices.getDisplayMedia({video: true, audio: false});}
                   }
                     playVideo(localVideo,localStream);
                     // console.log(localStream)
                     // console.log(localStream.getVideoTracks())
                     // console.log(localStream.getVideoTracks()[0].getSettings())
                     // console.log(localStream.getVideoTracks()[0].getSettings().aspectRatio)
                     setTextureAspect(localStream.getVideoTracks()[0].getSettings().aspectRatio);

                 } catch(err){
                     console.error('mediaDevice.getUserMedia() error:', err);
                 }
             }

             // Videoの再生を開始する
             async function playVideo(element, stream) {
                 element.srcObject = stream;
                 try {
                     await element.play();
                 } catch(erro) {
                     console.log('error auto play:' + erro);
                 }
             }
         };

         param[nameSrc] = "";
         // guis[name].add(param,nameSrc,videos).onChange(snap.obj[name][nameSrc]);
         // Dp.OBJ.Add({
         //   tab:"Mixer",
         //   group:name,
         //   type:"menu",
         //   obj:param,
         //   name:name+nameSrc,
         //   key:nameSrc,
         //   options:videos,
         //   func:snap.obj[name][nameSrc]
         // });
         $("#"+name+nameSrc).append(
           video
         );
         video.height = 30;

          var loaded = {"loaded":"waiting..."};
          // guis[name].add(loaded,'loaded');
          video.addEventListener('progress', function(e) {
             loaded.loaded = "loading..."
          });
          video.addEventListener('loadeddata', function(e) {
            loaded.loaded = "loadeddata"
            updateAllMat();
          });
          video.addEventListener('pause', function(e) {
            loaded.loaded = "pause"
          });
          video.addEventListener('play', function(e) {
            loaded.loaded = "play"
          });
          return texture;
        }

       //
       //
       // // var materialRef = [];
       // // materials[name + " Basic"] = materialBase[0];//new THREE.MeshBasicMaterial({transparent:true,map:texture});
       // materials[name + " Basic"].uniforms["videotexture_"+name].value = texture;
       // // materialOptions.push(name + " Basic");
       // // materialRef.push(materials[name + " Basic"]);
       //
       // materials[name + " Add"] = materialBase[1];//new THREE.MeshBasicMaterial({name:name,map:texture,color: 0xffffff,blending: THREE.AdditiveBlending,transparent:true});
       // materials[name + " Add"].uniforms["videotexture_"+name].value = texture;
       // // materialOptions.push(name + " Add");
       // // materialRef.push(materials[name + " Add"]);
       //
       //  materials[name + " Mask"] = materialBase[2];//new ChromaKeyMaterial(THREE.AdditiveBlending);
       //  // materials[name + " Mask"].map = texture;
       //  materials[name + " Mask"].uniforms["videotexture_"+name].value = texture;
       //  materials[name + " Mask"].uniforms.rendertexture.value = renderTarget.texture;
       //  // materialOptions.push(name + " Mask");
       //  // materialRef.push(materials[name + " Mask"]);
       //  var uniforms = materials[name + " Mask"].uniforms;

        snap.obj[name].ChromaKey = value => {
          setuniforms(name,"color",value,true);
          param.ChromaKey = value;
        };//uniforms.color.value.set(value)};
        snap.obj[name].ChromaKey(4258458);
        // guis[name+"conf"].addColor(param,'ChromaKey').onChange(snap.obj[name].ChromaKey);

        snap.obj[name].ChromaKey_hue = value => {setuniforms(name,"hue",value);param.ChromaKey_hue = value;};//uniforms.hue.value = value};
        snap.obj[name].ChromaKey_hue(0);
        // param.ChromaKey_hue = 0;
        // guis[name+"conf"].add(param,'ChromaKey_hue',-2,2).onChange(snap.obj[name].ChromaKey_hue);

        snap.obj[name].ChromaKey_saturation = value => {setuniforms(name,"saturation",value);param.ChromaKey_saturation = value;};//uniforms.saturation.value = value};
        snap.obj[name].ChromaKey_saturation(-0.4);
        // param.ChromaKey_saturation = -0.4;
        // guis[name+"conf"].add(param,'ChromaKey_saturation',-1,1).onChange(snap.obj[name].ChromaKey_saturation);

        snap.obj[name].ChromaKey_brightness = value => {setuniforms(name,"brightness",value);param.ChromaKey_brightness = value;};//uniforms.brightness.value = value};
        snap.obj[name].ChromaKey_brightness(-0.29);
        // param.ChromaKey_brightness = -0.29;
        // guis[name+"conf"].add(param,'ChromaKey_brightness',-1,1).onChange(snap.obj[name].ChromaKey_brightness);

        snap.obj[name].ChromaKey_contrast = value => {setuniforms(name,"contrast",value);param.ChromaKey_contrast = value;};//uniforms.contrast.value = value};
        snap.obj[name].ChromaKey_contrast(0.09);
        // param.ChromaKey_contrast = 0.09;
        // guis[name+"conf"].add(param,'ChromaKey_contrast',-1,1).onChange(snap.obj[name].ChromaKey_contrast);

        snap.obj[name].opacity = value => {
          setuniforms(name,"opacity_layer",value);
          // if(name == "material 5") setuniforms(name,"opacity_chDJ",value);
          // console.log(name)
          // materialBase["mat_"+name].uniforms.opacity_layer.value = value;
        };
        param.opacity = 0;
        // guis[name+"conf"].add(param,'opacity',0,1).onChange(snap.obj[name].opacity);

        // snap.obj[name].level = value => {materialBase["mat_"+name].uniforms.level.value = value;};
        // param.level = 0;
        // guis[name+"conf"].add(param,'level',0,1).onChange(snap.obj[name].level);

        // snap.val[name].material = materialBase["mat_"+name];

        if(materialBase["mat_"+name]){
          snap.obj[name].texture = value => {
            if(value == "RenderTexture"){
              // mat.videotexture_layer.value = renderTarget_layer.texture;
              // mat.videotexture_layer.value = afterimagePass.textureComp.texture//current_rt[0].texture;

              setuniforms(name,"videotexture_layer",afterimagePass.textureComp.texture)

              // if(name.indexOf('flip')==-1){setuniforms(name,"videotexture_layer",afterimagePass.textureComp.texture)}
              // else{setuniforms(name,"videotexture_layer",composer_layer.renderTarget2.texture)}

            }else{
              // mat.videotexture_layer.value = preset[value];
              setuniforms(name,"videotexture_layer",preset[value])
            }

            // inks.forEach(val => {
            //   var mat = materialBase["mat_"+name+val[0]].uniforms;
            //   if(value == "RenderTexture"){
            //     // mat.videotexture_layer.value = renderTarget_layer.texture;
            //     mat.videotexture_layer.value = afterimagePass.textureComp.texture//current_rt[0].texture;
            //   }else{
            //     mat.videotexture_layer.value = preset[value];
            //   }
            // })
            param.texture = value;
          };
          param.texture = "";
          // guis[name].add(param,'texture',presetOptions).onChange(snap.obj[name].texture);
          // var tex = makeVideo("video");
          // materialBase["mat_"+name].uniforms.videotexture_layer.value = tex;
          // materialBase["mat_"+name].uniforms.videotexture_chA.value = tex;//Backup
        }else{
          setValues("videotexture_"+name,makeVideo("video1"));
          setValues("videotexture2_"+name,makeVideo("video2"));
        }

        function setuniforms(name,key,value,set){
          inks.forEach(val => {
            if(materialBase["mat_"+name+val[0]]){
              if(set) materialBase["mat_"+name+val[0]].uniforms[key].value.set(value);
              else materialBase["mat_"+name+val[0]].uniforms[key].value = value;
            }
          })
        }

        function setValues(name,val,set){
          Object.values(materialBase).forEach( function( item ) {
            if(set) item.uniforms[name].value.set(val);
            else item.uniforms[name].value = val;
          });
        };


       //materialCh.forEach( function( item ) {
         // materialOptions.push(item + "Basic");
         // materials[item + "Basic"] = new THREE.MeshBasicMaterial();
         // materials[item + "Basic"].map = texture;
         // materials[item + "Basic"].transparent = true;
         // materialRef.push(materials[item + "Basic"]);

         // materialOptions.push(item + "Add");
         // materials[item + "Add"] = new THREE.MeshBasicMaterial({ color: 0xffffff,blending: THREE.AdditiveBlending,transparent:true});
         // materials[item + "Add"].map = texture;
         // materials[item + "Add"].transparent = true;
         // materialRef.push(materials[item + "Add"]);
       //});


       var trans = {};
       trans["mix_"+name] = [0,1.0];
       trans["opacity_"+name] = [0,1.0];

       if(name == "chA" || name == "chB") {
         trans["swap_"+name] = [0,1.0];
         trans["swap_"+name+"_LED"] = [0,1.0];
      }

       for (let [key, value] of Object.entries(trans)) {
           param[key] = 0;
           snap.obj[name][key] = (val) => {
             param[key] = val;
             updateAllMat();
           }

           // guis[name].add(param,key,value[0],value[1]).onChange(snap.obj[name][key]);
           // Dp.OBJ.Add({
           //   tab:"Mixer",
           //   group:name,
           //   type:"slider",
           //   obj:param,
           //   name:key,
           //   key:key,
           //   step:0.01,
           //   min:value[0],
           //   max:value[1],
           //   func:snap.obj[name][key]
           // });
       }

       param.name = name;
       // snap.obj[name].materialRef = materialRef;

       // function updateTrans(param){
       //   materialRef.forEach( function( item ) {
       //     var val,val2;
       //     if(materialChType[param.name] == "A"){
       //       val = snap.val.ABMix.mix;
       //
       //     }else if(materialChType[param.name] == "B"){
       //       val = 1 - snap.val.ABMix.mix
       //     }
       //
       //     if((item.name == "chA") && item.blending == THREE.AdditiveBlending){
       //       val2 = 1 - snap.val["chC"].opacity;
       //       console.log("chAのADD"+param.opacity+"を"+val2+"へ");
       //
       //     }else if((item.name == "chB") && item.blending == THREE.AdditiveBlending){
       //       val2 = 1 - snap.val["chD"].opacity;
       //       console.log("chBのADD"+param.opacity+"を"+val2+"へ");
       //
       //     }else{
       //       val2 = 1;
       //     }
       //
       //     item.opacity = param.opacity * val * val2;//MIXERの値を入れる
       //   });
       // }

       //materials[name] = {"material":material};
       //Dp.OBJ.Render();
   }

   function initMixer(){
     //MIXER
     snap.val.ABMix = {mix:0};
     snap.obj.ABMix = {"mix":() => updateAllMat()};
     // var mix = guis.mixer.addFolder("Mixer");
     // mix.add(snap.val.ABMix,"mix",0,1.0).onChange(snap.obj.ABMix.mix);
     //
     // Dp.OBJ.Add({
     //   tab:"Mixer",
     //   group:"Mix",
     //   type:"slider",
     //   obj:snap.val.ABMix,
     //   name:"Mixer",
     //   key:"mix",
     //   step:0.1,
     //   min:0,
     //   max:1,
     //   func:snap.obj.ABMix.mix
     // });
   }

   function updateAllMat(ch,video){
     materialCh.forEach( function( name ) {
       // snap.obj[item].opacity(snap.val[item].opacity);
       //snap.obj[name].materialRef.forEach( function( item ) {
       Object.values(materialBase).forEach( function( item ) {
         var param = snap.val[name];
         // if(materialChType[name] == "A"){
         //   item.uniforms.mix.value = snap.val.ABMix.mix;
         // }else if(materialChType[name] == "B"){
         //   item.uniforms.mix.value = 1 - snap.val.ABMix.mix
         // }else{
         //   item.uniforms.mix.value = 1;
         // }

        if(ch == name && item.uniforms["videotexture_"+name]){
          item.uniforms["videotexture_"+name].value = video;
          // console.log(item.uniforms["videotexture_"+name].value)
          // console.log(video)
        }

         if(item.uniforms["opacity_"+name]){
           item.uniforms.mix.value = snap.val.ABMix.mix;
           item.uniforms["opacity_"+name].value = param["opacity_"+name];// * val * val2;
           item.uniforms["mix_"+name].value = param["mix_"+name];// * val * val2;

           var mixA =  (name == "chA" || name == "chC") && snap.val.ABMix.mix == 1
           var mixB =  (name == "chB" || name == "chD") && snap.val.ABMix.mix == 0

           if(param["opacity_"+name] == 0 || mixA || mixB){
             setVideo(name+"video1",false);
             setVideo(name+"video2",false);
           }else{
             if(param["mix_"+name] == 1) setVideo(name+"video1",false);//snap.obj[name+"video1"].pause();
             else setVideo(name+"video1",true);//snap.obj[name+"video1"].play();

             if(param["mix_"+name] == 0) setVideo(name+"video2",false);//snap.obj[name+"video2"].pause();
             else setVideo(name+"video2",true);//snap.obj[name+"video2"].play();
           }

           function setVideo(name,play){
             if(snap.obj[name].src != ""){
               // if(play) snap.obj[name].play();
               // else snap.obj[name].pause()
             }
           }

           if(name == "chA" || name == "chB"){
             item.uniforms["swap_"+name].value = param["swap_"+name];
             item.uniforms["swap_"+name+"_LED"].value = param["swap_"+name+"_LED"];
           }

         }else{
           //item.uniforms["opacity_layer"].value = param["opacity_layer"];// * val * val2;

           // if(param["opacity_layer"] == 0){
           //   snap.obj[name+"video"].pause();
           // }else{
           //   snap.obj[name+"video"].play();
           // }
        }

         // if((item.name == "chA")){//} && item.blending == THREE.AdditiveBlending){
         //   val2 = 1 - snap.val["chC"]["opacity_"+name];
         //   // console.log("chAのADD"+param.opacity+"を"+val2+"へ");
         //
         // }else if((item.name == "chB")){// && item.blending == THREE.AdditiveBlending){
         //   val2 = 1 - snap.val["chD"]["opacity_"+name];
         //   // console.log("chBのADD"+param.opacity+"を"+val2+"へ");
         //
         // }

         // if(item.uniforms){

           // console.log(name + " " + param["opacity_"+name] * val + " > " + item.uniforms["opacity_"+name].value);
         // }else{
         //   item.opacity = param.opacity * val * val2;//MIXERの値を入れる
         // }

       });
     });
   }

   for (let [key, value] of Object.entries(snap.init.build)) {
     addObj(key,value);
   }

   // initBuild(snap.init.val);

   // var bgA = addObj("bgA",{"Geometry":"Sphere","radius":[0,500],"widthSegments":[0,60],"heightSegments":[0,40]});
   // var bgB = addObj("bgB",{"Geometry":"Box","width":[0,300],"height":[0,300],"depth":[0,300]});//, new THREE.MeshBasicMaterial());
   // var fgA = addObj("fgA",{"Geometry":"Plane","width":[0,1000],"height":[0,1000]});//,new THREE.MeshBasicMaterial({ color: 0xffffff,blending: THREE.AdditiveBlending,transparent:true}));
   // var plane = addObj("plane",{"Geometry":"Plane","width":[0,320],"height":[0,240]});

//    plane.mesh.rotation.y = Math.PI/-2;
//    snap.obj.ChromaKey = {ChromaKey:value => {plane.material.uniforms.color.value.set(value);}};
//    snap.val.ChromaKey = {"ChromaKey":0xd400}
//    guis.TimeBase.addColor(snap.val.ChromaKey,'ChromaKey').onChange(snap.obj.ChromaKey.ChromaKey);
//
   function addObj(name,parameters){
       // // video 要素を生成
       // var video = document.createElement( 'video' );
       // video.crossOrigin = 'anonymous';
       // video.loop = true;
       // video.muted = true;
       // video.setAttribute( 'webkit-playsinline', 'webkit-playsinline' );
       // video.setAttribute( 'playsinline', 'playsinline' );
       // video.setAttribute( 'muted', 'muted' );
       //
       // // video からテクスチャを生成
       // var texture = new THREE.Texture( video );
       // texture.generateMipmaps = false;
       // texture.minFilter = THREE.NearestFilter;
       // texture.maxFilter = THREE.NearestFilter;
       // texture.format = THREE.RGBFormat;
       //
       // // 動画に合わせてテクスチャを更新
       // setInterval( function () {
       //     if ( video.readyState >= video.HAVE_CURRENT_DATA ) {
       //         texture.needsUpdate = true;
       //     }
       // }, 1000 / 24 );

       // 球体を作成し、テクスチャに video を元にして生成したテクスチャを設定します
       //var geometry = new THREE.SphereBufferGeometry( 500, 60, 40 );
       // var mesh;
       var param = {};
       snap.val[name] = param;
       // guis[name] = gui.addFolder(name);
       // var material = material_;

      ///ch
      param.ch = materialOptions[0];
      snap.obj[name] = {
        ch:value => {
          // console.log(value,materialBase[value])
          // param.ch = value;
          updateMesh(param)
        }
      };
      // guis[name].add(param,'ch',materialOptions).onChange(snap.obj[name].ch);
      snap.obj[name].ch(param.ch);//初期化


       function updateMesh(param){

         const gnm = "group_"+parameters.group_name;
         if(parameters.group_name && !parameters.done2){
           if(typeof snap.val[gnm] != "boolean") snap.val[gnm] = false;
           if(!snap.obj[gnm+"_updates"]) snap.obj[gnm+"_updates"] = [];
           snap.obj[gnm+"_updates"].push([snap.obj[name],parameters.ch]);

           if(!snap.obj[gnm]){
             groups.push(gnm);
             snap.obj[gnm] = value => {
               // if(typeof value != "boolean") value = value.target.checked;
               console.log(name,gnm,value);
               snap.val[gnm] = value;
               snap.obj[gnm+"_updates"].forEach( function( pram ) {
                 pram[0].ch(pram[1]);
                 // updateMesh(item);
               //   if(value){
               //     scene.add(item);
               //   }else{
               //     scene.remove(item);
               //     // snap.init.sceneObj.add(item);
               //   }
               //   // item.visible = value;
               });
             };
           };
           parameters.done2 = true;
         }

         var obj3d;
          if(parameters.ref){
            if(!parameters.done){
              const p_ob = snap.init.sceneObj.children.find((v) => v.uuid === parameters.group_ref);
              obj3d = p_ob.children.find((v) => v.uuid === parameters.ref);
              obj3d.traverse((obj)=>{
                const d = obj.userData;
                if(d.build){
                  if(d.build.layer)d.layer = d.build.layer;
                  if(d.build.renderOrder)d.renderOrder = d.build.renderOrder;
                }

                if(d.val){
                  obj.material = materialBase[d.val.ch];
                }

                if(d.layer){
                  obj.layers.enable( eval(d.layer) );

                }else if(d.material){
                  if(d.material.envMap == "renderTarget") obj.material.envMap = renderTarget.texture;

                }

                if(d.renderOrder) obj.renderOrder = obj.renderOrder;

                var mixer
                if(obj.animations.length > 0) {
                  mixer = new THREE.AnimationMixer(obj);
                  Dp.mixers.push(mixer);

                  const states = {anims:[],current:0};
                  // const vals = snap.val.initVals.currentAnimations;
                  mixer.addEventListener('finished',playClip);

                  //モードを設定
                  snap.obj.initVals.currentAnimationsClip[obj.name] = (mode)=>{
                    snap.val.initVals.currentAnimations[obj.name] = mode;
                    playClip();
                  }
                  if(typeof snap.val.initVals.currentAnimations[obj.name] != "string") snap.val.initVals.currentAnimations[obj.name] = "stop";

                  //モードを検知して再生
                  function playClip(e){
                    mixer.stopAllAction();
                    if(states.anims.length == 0)return;

                    if(snap.val.initVals.currentAnimations[obj.name] == "playlist"){
                      states.current++
                      if(states.anims.length-1 < states.current)states.current = 0;
                      states.anims[states.current].play();

                    }else if(snap.val.initVals.currentAnimations[obj.name] == "random") {
                      const i = Math.floor(Math.random()*states.anims.length)
                      states.anims[i].play();

                    }
                  }

                  //Animationのクリップを作成
                  obj.animations.map((val)=>{
                    const nm = obj.name + "/" + val.name;
                    Dp.animations[nm] = mixer.clipAction(val);
                    Dp.animations[nm].setLoop(THREE.LoopOnce)
                    Dp.animations[nm].clampWhenFinished = true

                    if(typeof snap.val.initVals.currentAnimations[nm] != "boolian") snap.val.initVals.currentAnimations[nm] = false;
                    // Dp.mixers[nm] = mixer;

                    //Clip再生の設定
                    snap.obj.initVals.currentAnimationsClip[nm] = (play)=>{
                      snap.val.initVals.currentAnimations[nm] = play;
                      const i = states.anims.indexOf(Dp.animations[nm]);
                      if(play) {
                        if(i == -1) states.anims.push(Dp.animations[nm]);
                      }else if(i != -1) states.anims.splice(i,1);
                      playClip()
                    }
                  })
                }

                if(obj.type == "PerspectiveCamera"){
                  Dp.cameras.push(["imported","stop",obj.uuid,obj.name+"(読込)"])
                  Dp.cameraObjs.push(obj);
                }
              })
              // scene.add( obj3d );
              parameters.done = true;
              snap.obj[name].mesh = obj3d;
              updateTrans(param);
            }

          }else{
            // if(parameters.params) param.params = parameters.params;

           if(snap.obj[name].mesh){
              snap.obj[name].mesh.geometry.dispose();
              scene.remove(snap.obj[name].mesh);
              // snap.obj[name].mesh = undefined;
              delete(snap.obj[name].mesh);
            }

           var geometry;
           if(param.Geometry == "Sphere"|| param.Geometry == "SphereGeometry") {geometry = new THREE.SphereBufferGeometry(1,param.widthSegments,param.heightSegments);}
           if(param.Geometry == "Box"   || param.Geometry == "BoxGeometry") {geometry = new THREE.BoxBufferGeometry(1,1,1);}
           if(param.Geometry == "Plane" || param.Geometry == "PlaneGeometry") {geometry = new THREE.PlaneBufferGeometry(1,1,1);}

           var mat = materialBase[param.ch];
           obj3d = new THREE.Mesh( geometry, mat);//new THREE.MeshBasicMaterial( { map: texture } ) );
           obj3d.name = name;
           // if(param.params){
           //   console.log(param.params);
           //   obj3d.userData.params = param.params;
           // }
           if(param.layer == FX_SCENE || param.layer == DUMMY_SCENE)obj3d.layers.disableAll();
           if(param.layer) obj3d.layers.enable( param.layer );
           if(param.renderOrder) obj3d.renderOrder = param.renderOrder;
           snap.obj[name].mesh = obj3d;
           updateTrans(param);
           // if(!parameters.group_name)scene.add( obj3d );
         }

         if(!parameters.group_name) scene.add( snap.obj[name].mesh );
         else if(snap.val[gnm]) scene.add( snap.obj[name].mesh );
         else scene.remove( snap.obj[name].mesh );

       }

       //
       //  snap.obj[name] = {'src':async value => {
       //      if(value == "webCam" || value == "displayCapture"){
       //          startVideo(video,value);
       //      }else if(videosFile[value]){
       //          var a = await getmp4(value)
       //          video.src = URL.createObjectURL(a);
       //          video.play();
       //      }else{
       //          video.src = 'data/'+value;
       //          video.play();
       //      }
       //
       //      // getUserMediaでカメラ、マイクにアクセス
       //      async function startVideo(localVideo,value) {
       //          try{
       //              if(value == "webCam") localStream = await navigator.mediaDevices.getUserMedia({video: true, audio: false});
       //              if(value == "displayCapture") localStream = await navigator.mediaDevices.getDisplayMedia({video: true, audio: false});
       //              playVideo(localVideo,localStream);
       //          } catch(err){
       //              console.error('mediaDevice.getUserMedia() error:', err);
       //          }
       //      }
       //
       //      // Videoの再生を開始する
       //      async function playVideo(element, stream) {
       //          element.srcObject = stream;
       //          try {
       //              await element.play();
       //          } catch(erro) {
       //              console.log('error auto play:' + error);
       //          }
       //      }
       //  }};
       //  snap.val[name] = param;
       //
       //
       // param.src = "";
       // videosOpsion.push(data.labels[name].add(param,'src',videos).onChange(snap.obj[name].src));

       for (let [key, value] of Object.entries(parameters)) {
           if(key == "Geometry"){param.Geometry = value;}
           else if(key == "layer"){param.layer = value;}
           else if(key == "renderOrder"){param.renderOrder = value;}
           else{
               param[key] = value[1];
               snap.obj[name][key] = () => updateMesh(param);
               // guis[name].add(param,key,value[0],value[1]).onChange(
               //     snap.obj[name][key]
               // );
           }
       }

       updateMesh(param);
//       material.map = texture;
//       if(material.uniforms)material.uniforms.texture.value = texture;
//
//



       var trans = {"PosX":[-300,300],"PosY":[-300,300],"PosZ":[-300,300],"RotX":[-3,3],"RotY":[-3,3],"RotZ":[-3,3],"width":[-300,300],"height":[-300,300],"depth":[-300,300]};
       for (let [key, value] of Object.entries(trans)) {
           if(key == "width" || key == "height" || key == "depth"){
             param[key] = 1;
           }else{
             param[key] = 0;
           }
           snap.obj[name][key] = () => updateTrans(param);
           // guis[name].add(param,key,value[0],value[1]).onChange(snap.obj[name][key]);
       }

       function updateTrans(param){
          // if(param.matrix){
          //   const m4 = new THREE.Matrix4();
          //   const n = param.matrix;
          //   m4.set(
          //     n[0],
          //     n[1],
          //     n[2],
          //     n[3],
          //     n[4],
          //     n[5],
          //     n[6],
          //     n[7],
          //     n[8],
          //     n[9],
          //     n[10],
          //     n[11],
          //     n[12],
          //     n[13],
          //     n[14],
          //     n[15]
          //   );
          //   snap.obj[name].mesh.applyMatrix4(m4);
          //
          // }else{
           if(snap.obj[name].mesh.type != "Mesh") return;//読込オブジェクトがバグる

            snap.obj[name].mesh.scale.z = param.depth;
            snap.obj[name].mesh.position.x = param.PosX;
            snap.obj[name].mesh.position.y = param.PosY;
            snap.obj[name].mesh.position.z = param.PosZ;
            snap.obj[name].mesh.rotation.x = param.RotX;
            snap.obj[name].mesh.rotation.y = param.RotY;
            snap.obj[name].mesh.rotation.z = param.RotZ;

            if(!param.textureAspect){
              snap.obj[name].mesh.scale.x = param.width;
              snap.obj[name].mesh.scale.y = param.height;

            }else{
              var xy = param.width + param.height;
              snap.obj[name].mesh.scale.x = param.textureAspect / (param.textureAspect + 1) * xy;
              snap.obj[name].mesh.scale.y = 1 / (param.textureAspect + 1) * xy;
            }
          // }
       }

       //return {"mesh":mesh};
       // meshs[name] = mesh;
   }

   // レンダラーを生成
   renderer = new THREE.WebGLRenderer({antialias: true});
   renderer.setPixelRatio( window.devicePixelRatio );
   renderer.setSize( Utl.CONF.defaultWidth , Utl.CONF.defaultHeight );//window.innerWidth, window.innerHeight );

   // // コンテナの準備
   // container = document.getElementById( 'canvas-frame' );
   // container.appendChild( renderer.domElement );


   Dp.renderer = renderer.domElement;
   Dp.rendererObj = renderer;

   // renderer2 = new THREE.WebGLRenderer({antialias: true});
   // renderer2.setPixelRatio( window.devicePixelRatio );
   // renderer2.setSize( snap.val.cuts.dispWidth ,snap.val.cuts.dispHeight );//window.innerWidth, window.innerHeight );
   // container.appendChild( renderer2.domElement );
   // OBJ.Dp.rendererStream = renderer2.domElement.captureStream();

   // snap.obj.renderer = renderer.domElement;
   // OBJ.Dp.WEBRTCPreview();
   // OBJ.Dp.channel.postMessage({massage:"hidePreview"});
   // OBJ.Dp.makeOffer(renderer.domElement.captureStream());

   // var a = document.getElementById('remote_video')
   // a.srcObject = renderer.domElement.captureStream()

   renderSceneCamera1 = new RenderPass( scene, camera );
   renderSceneCamera2 = new RenderPass( scene, camera2 );
   Dp.renderSceneCamera1 = renderSceneCamera1;

   //bloomPass
   bloomPass = new UnrealBloomPass( new THREE.Vector2( snap.val.cuts.dispWidth, snap.val.cuts.dispHeight ), 1.5, 0.4, 0.85 );
   // bloomPass.threshold = params.bloomThreshold;
   // bloomPass.strength = params.bloomStrength;
   // bloomPass.radius = params.bloomRadius;

   composer = new EffectComposer( renderer );
   composer.renderToScreen = false;
   composer.addPass( renderSceneCamera1 );
   composer.addPass( bloomPass );


   composer_layer = new EffectComposer( renderer );
   composer_layer.renderToScreen = true;//false;
   composer_layer.addPass( renderSceneCamera2 );

   afterimagePass = new AfterimagePass(0);
   afterimagePass.renderToScreen = false;
   composer_layer.addPass( afterimagePass );

   materialBase["mat_material 5 Key"].uniforms.rendertexture.value = renderTarget.texture;
   materialBase.Black.uniforms.rendertexture.value = renderTarget.texture;

   finalPass = new ShaderPass(
		new THREE.ShaderMaterial( {
			uniforms: {
				baseTexture: { value: null },
				bloomTexture: { value: composer.renderTarget2.texture }
			},
			vertexShader: decodeURIComponent(Dp.OBJ.user.data.vertexshader2),//document.getElementById( 'vertexshader2' ).textContent,
			fragmentShader: decodeURIComponent(Dp.OBJ.user.data.fragmentshader2),//document.getElementById( 'fragmentshader2' ).textContent,
			defines: {}
		} ), "baseTexture"
	);
	finalPass.needsSwap = true;

  // console.log(decodeURI(Dp.OBJ.user.data.vertexshader));
  // console.log(decodeURI(Dp.OBJ.user.data.fragmentShader));
  // console.log(decodeURI(Dp.OBJ.user.data.vertexshader2));
  // console.log(decodeURI(Dp.OBJ.user.data.fragmentshader2));

	finalComposer = new EffectComposer( renderer );
	finalComposer.addPass( renderSceneCamera1 );
	finalComposer.addPass( finalPass );


   // ドラッグ・スワイプ操作を設定
   // container.addEventListener( EVENT.TOUCH_START, onDocumentMouseDown, false );

   // 画面のリサイズに対応
   window.addEventListener( 'resize', onWindowResize, false );
   onWindowResize( null );

   //Camera
   // guis.TimeBase.add(snap.obj.TimeBase,'lat',-85,85).onChange(val => snap.val.TimeBase.lat = val);
   // guis.TimeBase.add(snap.obj.TimeBase,'lon',-180,180).onChange(val => snap.val.TimeBase.lon = val);

   //scene.fog = new THREE.Fog(0xFFFFFF, 0, 100);

   $('.c > input:text').css('height', '20px');

   snap.val.bloomExposure = 1;
   snap.obj.bloomExposure = value => {
     console.log("bloomExposure",value)
     renderer.toneMappingExposure = Math.pow( value, 4.0 );
     snap.val.bloomExposure = Number( value );
   };
   // guis.TimeBase.add(snap.val.TimeBase,'exposure',0.1,2).onChange(snap.obj.TimeBase.exposure);

   snap.val.bloomThreshold = 0.28;
   snap.obj.bloomThreshold = value => {
     console.log("bloomThreshold",value)
     bloomPass.threshold = Number( value );
     snap.val.bloomThreshold = Number( value );
   };
   // guis.TimeBase.add(snap.val.TimeBase,'bloomThreshold',0.0, 1.0).onChange(snap.obj.TimeBase.bloomThreshold);
   // Dp.OBJ.Add({
   //   tab:"Setting",
   //   group:"Bloom",
   //   type:"slider",
   //   obj:TimeBase,
   //   name:'Threshold',
   //   key:'bloomThreshold',
   //   step:0.1,
   //   min:0,
   //   max:1,
   //   func:TimeBase.bloomThreshold
   // });

   snap.val.bloomStrength = 3;
   snap.obj.bloomStrength = value => {
     console.log("bloomStrength",value)
     bloomPass.strength = Number( value );
     snap.val.bloomStrength = Number( value );
   };
   // data.labels.TimeBase.add(snap.val.TimeBase,'bloomStrength',0.0, 3.0).onChange(snap.obj.TimeBase.bloomStrength);
   // Dp.OBJ.Add({
   //   tab:"Setting",
   //   group:"Bloom",
   //   type:"slider",
   //   obj:TimeBase,
   //   name:'Strength',
   //   key:'bloomStrength',
   //   step:0.1,
   //   min:0,
   //   max:3,
   //   func:TimeBase.bloomStrength
   // });

   snap.val.bloomRadius = 1;
   snap.obj.bloomRadius = value => {
     console.log("bloomRadius",value)
     bloomPass.radius = Number( value );
     snap.val.bloomRadius = Number( value );
   };
   // guis.TimeBase.add(snap.val.TimeBase,'bloomRadius',0.0, 1.0 ).step( 0.01 ).onChange(snap.obj.TimeBase.bloomRadius);
   // Dp.OBJ.Add({
   //   tab:"Setting",
   //   group:"Bloom",
   //   type:"slider",
   //   obj:TimeBase,
   //   name:'Radius',
   //   key:'bloomRadius',
   //   step:0.1,
   //   min:0,
   //   max:1,
   //   func:TimeBase.bloomRadius
   // });

    //
		// gui.add( params, 'exposure', 0.1, 2 ).onChange( function ( value ) {
		// 	renderer.toneMappingExposure = Math.pow( value, 4.0 );
		// } );
    //
		// gui.add( params, 'bloomThreshold', 0.0, 1.0 ).onChange( function ( value ) {
		// 	bloomPass.threshold = Number( value );
		// } );

		// gui.add( params, 'bloomStrength', 0.0, 3.0 ).onChange( function ( value ) {
		// 	bloomPass.strength = Number( value );
		// } );
    //
		// gui.add( params, 'bloomRadius', 0.0, 1.0 ).step( 0.01 ).onChange( function ( value ) {
		// 	bloomPass.radius = Number( value );
		// } );

    fx.func(
      {
       // "option": "mix",
       // "lock": 1,
       // "thumb": [
       //   "01",
       //   "Flash"
       // ],
       "data": {
         "mix": {}
       },
       // "cleardata": {
       //   "mix": {}
       // },
       // "auto": [
       //   1,
       //   1,
       //   1
       // ]
     },{}
   )

   snap.obj.chA.video1("");
   snap.obj.chC.video1("");
   // updateAllMat("chB",afterimagePass.textureComp.texture);
   updateAllMat("chD",afterimagePass.textureComp.texture);
   // updateAllMat("chDJ",afterimagePass.textureComp.texture);
   // Dp.channel.postMessage({massage:"setMov",param:{ch:"chD",mov:"RenderTexture",opacity:1.0}});
   //snap.obj.material1

 }

 function onWindowResize ( event ) {
   if(camera){
     function setAspect(camera,conf){
       //window.innerWidth / window.innerHeight;
       if(conf) camera.aspect = Utl.CONF.defaultWidth / Utl.CONF.defaultHeight
       else camera.aspect = snap.val.cuts.dispWidth / snap.val.cuts.dispHeight;
       camera.updateProjectionMatrix();
     }
     Dp.cameraObjs.map((cam)=>{setAspect(cam)})
     setAspect(camera)//,true)
     setAspect(camera2)//,true)

     // camera.aspect = snap.val.cuts.dispWidth / snap.val.cuts.dispHeight;//window.innerWidth / window.innerHeight;
     // camera.updateProjectionMatrix();
     // camera2.aspect = snap.val.cuts.dispWidth / snap.val.cuts.dispHeight;//window.innerWidth / window.innerHeight;
     // camera2.updateProjectionMatrix();
     // renderer.setSize(Utl.CONF.defaultWidth , Utl.CONF.defaultHeight);//window.innerWidth, window.innerHeight );
     // renderer.setSize(snap.val.cuts.dispWidth , snap.val.cuts.dispHeight);//window.innerWidth, window.innerHeight );
     // renderer2.setSize(snap.val.cuts.dispWidth , snap.val.cuts.dispHeight);//window.innerWidth, window.innerHeight );
     composer.setSize(snap.val.cuts.dispWidth , snap.val.cuts.dispHeight);
     composer_layer.setSize(Utl.CONF.defaultTextureWidth , Utl.CONF.defaultTextureHeight);//snap.val.cuts.dispWidth , snap.val.cuts.dispHeight);
     finalComposer.setSize(snap.val.cuts.dispWidth , snap.val.cuts.dispHeight);
     // $('#page-wrapper').css('padding-left', (snap.val.cuts.dispWidth+10)+'px');
     // $('#page-wrapper').css('padding-right', (270)+'px');
     $(renderer.domElement).css('width', '100%');
     $(renderer.domElement).css('height','auto');
     // $(renderer2.domElement).css('width', '100%');
     // $(renderer2.domElement).css('height','auto');

     var vFOV = THREE.MathUtils.degToRad( camera.fov ); // convert vertical fov to radians
     cameraHeight = 2 * Math.tan( vFOV / 2 ) * dfaultDistance; // visible height
     // const asp = Utl.CONF.defaultTextureWidth / Utl.CONF.defaultTextureHeight
     cameraWidth = cameraHeight * camera.aspect;           // visible width

     // renderTarget_layer = new THREE.WebGLRenderTarget(snap.val.cuts.dispWidth , snap.val.cuts.dispHeight);
     // renderTarget_layer_swap = new THREE.WebGLRenderTarget(snap.val.cuts.dispWidth , snap.val.cuts.dispHeight);

     // console.log(cameraWidth,cameraHeight)
   }
 }

 function onDocumentMouseDown( event ) {
   event.preventDefault();
   if(event.clientX) {
     onMouseDownMouseX = event.clientX;
     onMouseDownMouseY = event.clientY;
   } else if(event.touches) {
     onMouseDownMouseX = event.touches[0].clientX
     onMouseDownMouseY = event.touches[0].clientY;
   } else {
     onMouseDownMouseX = event.changedTouches[0].clientX
     onMouseDownMouseY = event.changedTouches[0].clientY
   }
   onMouseDownLon = TimeBase.lon;
   onMouseDownLat = TimeBase.lat;
   document.addEventListener( EVENT.TOUCH_MOVE, onDocumentMouseMove, false );
   document.addEventListener( EVENT.TOUCH_END, onDocumentMouseUp, false );
 }

 function onDocumentMouseMove( event ) {
   event.preventDefault();
   if(event.clientX) {
     var touchClientX = event.clientX;
     var touchClientY = event.clientY;
   } else if(event.touches) {
     var touchClientX = event.touches[0].clientX
     var touchClientY = event.touches[0].clientY;
   } else {
     var touchClientX = event.changedTouches[0].clientX
     var touchClientY = event.changedTouches[0].clientY
   }
   TimeBase.lon = ( touchClientX - onMouseDownMouseX ) * -0.15 + onMouseDownLon;
   TimeBase.lat = ( touchClientY - onMouseDownMouseY ) * -0.15 + onMouseDownLat;
 }

 function onDocumentMouseUp( event ) {
   document.removeEventListener( EVENT.TOUCH_MOVE, onDocumentMouseMove, false );
   document.removeEventListener( EVENT.TOUCH_END, onDocumentMouseUp, false );
 }

 function animate() {
   requestAnimationFrame(animate);
   render();
   // renderer.setAnimationLoop( render );
 }

 function render() {
     updateTexture.forEach( function( item ) {
       // if ( item.image.readyState >= item.image.HAVE_CURRENT_DATA ) {
           item.needsUpdate = true;
       // }
     });

     var cut = snap.val.cuts;
     var t = new Date().getTime();
     var b = 60000.0 / snap.val.TimeBase.bpm * 16.0;
     if(TimeBase.save + b < t) {
       TimeBase.save = t;
       if(cut.mode == "loop"){
         cut.current++;
         if(cut.current >= cut.length) cut.current = 0;
       }else if(cut.mode == "random"){
         cut.current = Math.floor(Math.random()*cut.length);
       }
     }

     var x = (t - TimeBase.save) / b;
     TimeBase.base = x;
     // x = x*2%1;

     TimeBase.ease = EasingFunctions.easeInOutQuart(x);

     TimeBase.pinpon = Math.abs(x-0.5);

     if(x<0.5){
         TimeBase.pinponEase = EasingFunctions.easeInQuart(TimeBase.pinpon);
     }else{
         TimeBase.pinponEase = EasingFunctions.easeOutQuart(TimeBase.pinpon);
     }

     //Dulay
     var y;
     if(x>0.25) y = x - 0.25;
     else y = x + 0.75;

     TimeBase.pinponDulay = Math.abs(y-0.5)*2;

     if(y<0.5){
         TimeBase.pinponDulayEase = EasingFunctions.easeInQuart(TimeBase.pinponDulay);
     }else{
         TimeBase.pinponDulayEase = EasingFunctions.easeOutQuart(TimeBase.pinponDulay);
     }

     //console.log(snap.val);


   // var lat = TimeBase.lat + TimeBase.latMotionSize * TimeBase[TimeBase.latMotion];
   // var lon = TimeBase.lon + TimeBase.lonMotionSize * TimeBase[TimeBase.lonMotion];

  //  /**
  //  * 緯度経度から位置を算出します。
  //  * @param {number} latitude 緯度です。
  //  * @param {number} longitude 経度です。
  //  * @param {number} radius 半径です。
  //  * @returns {THREE.Vector3} 3Dの座標です。
  //  * @see https://ics.media/entry/10657
  //  */
  // function translateGeoCoords(latitude, longitude, radius,camera) {
  //   // 仰角
  //   const phi = (latitude * Math.PI) / 180;
  //   // 方位角
  //   const theta = ((longitude - 180) * Math.PI) / 180;
  //
  //   camera.position.x = -radius * Math.cos(phi) * Math.cos(theta);
  //   camera.position.y = radius * Math.sin(phi);
  //   camera.position.z = radius * Math.cos(phi) * Math.sin(theta);
  // }

  function calcPosFromLatLonRad( lat, lon,radius,camera) {

    var spherical = new THREE.Spherical(
      radius,
      THREE.Math.degToRad(90 - lon),
      THREE.Math.degToRad(lat)
    );

    var vector = new THREE.Vector3();
    vector.setFromSpherical(spherical);
    camera.position.set(vector.x, vector.y, vector.z);
  }

   function getVal(start,end,type){
     var diff = end - start;
     return start + diff * TimeBase[type];
   }

   if(typeof cut.current == "number"){

     const starts = snap.val["cut"+cut.current+"start"];
     const ends = snap.val["cut"+cut.current+"end"];
     var distance = getVal(starts.distance,ends.distance,cut.type);
     var lat = getVal(starts.lat,ends.lat,cut.type);
     var lon = getVal(starts.lon,ends.lon,cut.type);

     // lat = Math.max( - 85, Math.min( 85, lat ) );
     // phi = THREE.Math.degToRad( 90 - lat );
     // theta = THREE.Math.degToRad( lon );
     // camera.position.x = distance * Math.sin( phi ) * Math.cos( theta );
     // camera.position.y = distance * Math.cos( phi );
     // camera.position.z = distance * Math.sin( phi ) * Math.sin( theta );

     //translateGeoCoords(lat,lon,distance,camera)

     function cameraInit(camera){
       calcPosFromLatLonRad(lat,lon,distance,camera)
       camera.lookAt( new THREE.Vector3(
         getVal(starts.PosX,ends.PosX,cut.type),
         getVal(starts.PosY,ends.PosY,cut.type),
         getVal(starts.PosZ,ends.PosZ,cut.type),
       ));
     }

     cameraInit(camera);

    const dx=camera.position.x - snap.val.imported_dj_booth_DJ_0.PosX
    const dy=camera.position.z - snap.val.imported_dj_booth_DJ_0.PosZ
    const angle=Math.atan2(dy,dx)

     //console.log(angle);
     snap.val.imported_dj_booth_DJ_0.RotY = -angle/2 + (1.57)/2;
     snap.obj.imported_dj_booth_DJ_0.RotY();
   }


   //fx
   Object.values(TimeBase.fx).forEach(fx => {
     snap.obj.fx(fx);
   })

   Object.keys(TimeBase.tweens).forEach(key => {
     var tw = TimeBase.tweens[key];
     tw.opt.tweenInit = false;
     tw.opt.adjust = (Date.now() - tw.opt.start) / tw.opt.tween;
     if(tw.opt.adjust > 1){
       tw.opt.adjust = 1;
       delete TimeBase.tweens[key];
     }
     if(tw.opt.type == "clear") tw.opt.adjust = (1-tw.opt.adjust);
     // console.log(tw);
     tw.func(tw.param,tw.opt);
     // snap.obj.fx(fx);
   })



   // composer.render();
   // renderer.render( scene, camera );

   //const tx = new PIXI.Texture.from(renderer.domElement);
   //pixi.img.texture = tx;
   //pixi.img.texture.update();

   // renderer.render(scene, camera,renderTarget);
   // draw render target scene to render target

   //camera2のレンダリング時だけFXを出す
   // scene.traverse((obj)=>{
     // if ( obj.isMesh && fxLayer.test( obj.layers )) obj.visible = true;
   // });
   if ( Dp.mixers.length > 0 ) {
     var mixerUpdateDelta = clock.getDelta();
      for ( var i = 0; i < Dp.mixers.length; ++ i ) {
        if (Dp.mixers[ i ]) Dp.mixers[ i ].update(mixerUpdateDelta);
      }
   }

   renderer.setSize(Utl.CONF.defaultWidth , Utl.CONF.defaultHeight);//window.innerWidth, window.innerHeight );
   renderer.setRenderTarget(renderTarget);
   renderer.render(scene, camera);//Dp.activeCamera);

   renderer.setRenderTarget(null);
   composer_layer.render();

   if(snap.val.cuts.camera == 0){
     renderer.setSize(snap.val.cuts.dispWidth , snap.val.cuts.dispHeight);//window.innerWidth, window.innerHeight );

     // render scene with bloom
     renderBloom();

     // render the entire scene, then render bloom scene on top
     finalComposer.render();
   }

   $(renderer.domElement).css('width', '100%');
   $(renderer.domElement).css('height','auto');

   // renderer2.render(scene, camera2);

   //camera2のレンダリングが終わったらFXを消す
   // scene.traverse((obj)=>{
     // if ( obj.isMesh && fxLayer.test( obj.layers )) obj.visible = false;
   // });


   // renderTarget_layer_swap = renderTarget_layer.texture.clone();
   // renderTarget_layer_swap.needsUpdate = true;




   if(Dp.fullscreenCanvasCtx){
     // copy the rendered scene to this element's canvas
     Dp.fullscreenCanvasCtx.globalCompositeOperation = 'copy';
     Dp.fullscreenCanvasCtx.drawImage(
         Dp.renderer,
         0, 0, Dp.renderer.width, Dp.renderer.height,  // src rect
         0, 0, Dp.fullscreenCanvas.width, Dp.fullscreenCanvas.height);                              // dst rect
  }


  if(Dp.canvasCapture){
    //サムネ作成
    const context = Dp.canvasCapture.getContext('2d')

    context.globalCompositeOperation = 'copy';
    context.drawImage(
        Dp.renderer,
        0, 0, Dp.renderer.width, Dp.renderer.height,  // src rect
        0, 0, Dp.canvasCapture.width, Dp.canvasCapture.height);                              // dst rect

    snap.val.banks[1].thumb = Dp.canvasCapture.toDataURL('image/jpeg');
    Dp.canvasCapture.remove();
    Dp.canvasCapture = false;

    Dp.OBJ.setBanks(snap.val.banks);
  }


   // renderer.setRenderTarget(current_rt[0]);
   // renderer.render(scene, camera);
   // renderer.setRenderTarget(null);
   //
   // current_rt = [current_rt[1],current_rt[0]];

   function renderBloom() {
      scene.traverse( darkenNonBloomed );
   		composer.render();
      scene.traverse( restoreMaterial );
   }

   function checkMask(uniforms){
     if(uniforms){
       if(uniforms.mask){
         return uniforms.mask.value
      }
    }
  }

   function darkenNonBloomed( obj ) {
     	if ( obj.isMesh && bloomLayer.test( obj.layers ) === false ) {

     		materials2[ obj.uuid ] = obj.material;
        if(checkMask(obj.material.uniforms)){
          materials2[ obj.uuid ] = obj.material.uniforms.brightness.value;
          obj.material.uniforms.brightness.value = -1;

        }else if(bloomIgnorLayer.test( obj.layers )) {
          obj.visible = false;

        }else{
          obj.material = darkMaterial;
        }

     	}

     }

   function restoreMaterial( obj ) {

   	if ( materials2[ obj.uuid ] ) {
      obj.visible = true;
      if(checkMask(obj.material.uniforms)){
        obj.material.uniforms.brightness.value = materials2[ obj.uuid ];
      }else{
        obj.material = materials2[ obj.uuid ];
      }
   		delete materials2[ obj.uuid ];

   	}

   }
 }
 Dp.mainLoaded = true;
};


/*
* Easing Functions - inspired from http://gizma.com/easing/
* only considering the t value for the range [0, 1] => [0, 1]
*/
var EasingFunctions = {
 // no easing, no acceleration
 linear: t => t,
 // accelerating from zero velocity
 easeInQuad: t => t*t,
 // decelerating to zero velocity
 easeOutQuad: t => t*(2-t),
 // acceleration until halfway, then deceleration
 easeInOutQuad: t => t<.5 ? 2*t*t : -1+(4-2*t)*t,
 // accelerating from zero velocity
 easeInCubic: t => t*t*t,
 // decelerating to zero velocity
 easeOutCubic: t => (--t)*t*t+1,
 // acceleration until halfway, then deceleration
 easeInOutCubic: t => t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1,
 // accelerating from zero velocity
 easeInQuart: t => t*t*t*t,
 // decelerating to zero velocity
 easeOutQuart: t => 1-(--t)*t*t*t,
 // acceleration until halfway, then deceleration
 easeInOutQuart: t => t<.5 ? 8*t*t*t*t : 1-8*(--t)*t*t*t,
 // accelerating from zero velocity
 easeInQuint: t => t*t*t*t*t,
 // decelerating to zero velocity
 easeOutQuint: t => 1+(--t)*t*t*t*t,
 // acceleration until halfway, then deceleration
 easeInOutQuint: t => t<.5 ? 16*t*t*t*t*t : 1+16*(--t)*t*t*t*t
}

var removeEvent = (function() {
    if (window.removeEventListener) {
        return function(element, type, handler) {
            // other
            element.removeEventListener(type, handler, false);
            return element;
        };
    } else if (window.detachEvent) {
        return function(element, type, handler) {
            // IE
            element.detachEvent('on' + type, handler);
            return element;
        };
    } else {
        return function(element) {
            return element;
        };
    }
})();

ChromaKeyMaterial = function (blend,mask,skip,rev,flip) {
 THREE.ShaderMaterial.call(this);
 var rev = rev == true;
 if(!flip) flip = [0,0];

// video = document.createElement('video');
 // video.loop = true;
 // video.src = url;
 // video.load();
 //video.play();

 // var videoImage = document.createElement('canvas');
 // if (window["webkitURL"]) document.body.appendChild(videoImage);
 // videoImage.width = width;
 // videoImage.height = height;

 var keyColorObject = new THREE.Color(0,0,0);

 // var videoImageContext = videoImage.getContext('2d');
 // // background color if no video present
 // videoImageContext.fillStyle = '#' + keyColorObject.getHexString();
 // videoImageContext.fillRect(0, 0, videoImage.width, videoImage.height);
 //
 // var videoTexture = new THREE.Texture(videoImage);
 // videoTexture.minFilter = THREE.LinearFilter;
 // videoTexture.magFilter = THREE.LinearFilter;

 // this.update = function () {
 //   if (video.readyState === video.HAVE_ENOUGH_DATA) {
 //     videoImageContext.drawImage(video, 0, 0);
 //     if (videoTexture) {
 //       videoTexture.needsUpdate = true;
 //     }
 //   }
 // }


if(blend.blending != THREE.CustomBlending){
  blend = {
    blending:blend,
    blendEquation:THREE.AddEquation,
    blendSrc:THREE.SrcAlphaFactor,
    blendDst:THREE.OneMinusSrcAlphaFactor,
  }
}

 this.setValues({

   uniforms: {
     rendertexture: {
       type: "t",
       value: null
     },
     videotexture_chA: {
       type: "t",
       value: null
     },
     videotexture_chB: {
       type: "t",
       value: null
     },
     videotexture_chC: {
       type: "t",
       value: null
     },
     videotexture_chD: {
       type: "t",
       value: null
     },
     videotexture_chDJ: {
       type: "t",
       value: null
     },
     videotexture_layer: {
       type: "t",
       value: null
     },
     videotexture2_chA: {
       type: "t",
       value: null
     },
     videotexture2_chB: {
       type: "t",
       value: null
     },
     videotexture2_chC: {
       type: "t",
       value: null
     },
     videotexture2_chD: {
       type: "t",
       value: null
     },
     videotexture2_chDJ: {
       type: "t",
       value: null
     },
     mask: {
       type: "b",
       value: mask
     },
     reverse: {
       type: "b",
       value: rev
     },
     flipH: {
       type: "f",
       value: flip[0],
     },
     flipV: {
       type: "f",
       value: flip[1],
     },
     skip: {
       type: "i",
       value: skip
     },
     color: {
       type: "c",
       value: keyColorObject
     },
     mix: {
       type: "f",
       value: 1.0
     },
     swap_chA: {
       type: "f",
       value: 1.0
     },
     swap_chB: {
       type: "f",
       value: 1.0
     },
     swap_chA_LED: {
       type: "f",
       value: 1.0
     },
     swap_chB_LED: {
       type: "f",
       value: 1.0
     },
     mix_chA: {
       type: "f",
       value: 1.0
     },
     mix_chB: {
       type: "f",
       value: 1.0
     },
     mix_chC: {
       type: "f",
       value: 1.0
     },
     mix_chD: {
       type: "f",
       value: 1.0
     },
     mix_chDJ: {
       type: "f",
       value: 1.0
     },
     opacity_chA: {
       type: "f",
       value: 1.0
     },
     opacity_chB: {
       type: "f",
       value: 1.0
     },
     opacity_chC: {
       type: "f",
       value: 1.0
     },
     opacity_chD: {
       type: "f",
       value: 1.0
     },
     opacity_chDJ: {
       type: "f",
       value: 1.0
     },
     opacity_layer: {
       type: "f",
       value: 1.0
     },
     // level: {
     //   type: "f",
     //   value: 1.0
     // },
     brightness: {
       type: "f",
       value: 0
     },
     contrast: {
       type: "f",
       value: 0
     },
     hue: {
       type: "f",
       value: 0.0
     },
     saturation: {
       type: "f",
       value: 0.0
     }
   },
   vertexShader: decodeURIComponent(Dp.OBJ.user.data.vertexshader),//document.getElementById('vertexShader').textContent,
   fragmentShader: FRAGMENTSHADER,//decodeURIComponent(Dp.OBJ.user.data.fragmentShader),//document.getElementById('fragmentShader').textContent,
   transparent: true,
   // blending: blend.blending,
   // blendEquation: blend.blendEquation,
   // blendSrc: blend.blendSrc,
   // blendDst: blend.blendDst,
 });

 this.blending = blend.blending;
 this.blendEquation = blend.blendEquation;
 this.blendSrc = blend.blendSrc;
 this.blendDst = blend.blendDst;
}

var ChromaKeyMaterial;
ChromaKeyMaterial.prototype = Object.create(THREE.ShaderMaterial.prototype);
